import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import {
  CardHeader,
  CardBody, CardTitle, Col, Container,
  Form, FormFeedback, Input, Label, Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
  Pagination, PaginationItem, PaginationLink,
  FormGroup,Collapse,Tooltip
} from "reactstrap";
import Card from "components/PurpleTheme/Card";
import Select from "react-select";
import countryCodes from './CountryCode';
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import * as Yup from "yup";
import withRouter from "components/Common/withRouter";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  toggleSsoOnlyLogin as onToggleSsoOnlyLogin,
  getSsoOnlyLogin as onGetSsoOnlyLogin,
  postAllowedDomainsRestrictions as onPostAllowedDomainRestrictions,
  deleteAllowedDomainsRestrictions as onDeleteAllowedDomainRestrictions,
  getAllowedDomainsRestrictions as onGetAllowedDomainRestrictions,
  getUsers as onGetUsers,
  inviteUser as onInviteUser,
  deleteUser as onDeleteUser,
  updateUser as onUpdateUser,
  getOrganization as onGetOrganization,
  getSubscription as onGetSubscription,
  updateBillingDetails as onUpdateBillingDetails,
  getRoles as onGetRoles,
  updateRoles as onUpdateRoles,
  createBluejayTeam as onCreateBluejayTeam,
  getBluejayTeam as onGetBluejayTeam,
  deleteBluejayTeam as onDeleteBluejayTeam,
  deleteServiceFromTeam as onDeleteServiceFromTeam,
  getUnmappedTeamServices as onGetUnmappedServices,
  mapServicesToTeam as onMapServicesToTeam,
  nonTeamUsers as onNonTeamUsers,
  addUsersToTeam as onAddUsersToTeam,
  removeUserFromTeam as onRemoveUserFromTeam,
  getOrgPrimaryNotificationChannels as onGetOrgPrimaryNotificationChannels,
  updateOrgPrimaryNotificationChannels as onUpdateOrgPrimaryNotificationChannels,
  getAlertDeploymentCount as onGetAlertDeploymentCount,
  getResourceScanCount as onGetResourceScanCount,
  getDailyResourceCount as onGetDailyResourceCount,
  getMonthlyResourceCount as onGetMonthlyResourceCount,
  updateTwoFactorOrgEnabled,
  getPaginatedUsers as onGetPaginatedUsers,
  getUsersCount as onGetUsersCount, togglePublishStatusPage, postSetOrgMaintenance, postExternalPageDetails,
  createChangeEventWebhook as onCreateChangeEventWebhook,
  resetCreateEventWebhook,
  getChangeEventWebhooks as onGetChangeEventWebhooks,
  getChangeEvents as onGetChangeEvents,
  getChangeEventById as onGetChangeEventById, postCreateOktaSSOIntegration, getOktaSSOIntegration,


} from "../../store/organization/actions";
import {withTranslation} from "react-i18next";
import './organization.scss';
import Loader from "../../components/Loader/Loader";
import sendingEmailLottie from '../../assets/images/sending_email_lottie.json';
import deleteUserLottie from '../../assets/images/delete_user_lottie.json';
import OrganizationServices from "../../components/OrganizationService/service.js";
import Switch from "react-switch";
import DocsTooltip from "components/Common/DocsTooltip";
import {showNotification} from "../../components/Common/notification";
import OrganizationServiceMapping from "components/OrganizationService/OrganizationServiceMapping";
import OnUpdateProfilePicModal from "../Profile/OnUpdateProfilePicModal";
import InitialsAvatar from "../Profile/InitialsAvatar";
import profileImg from "../../assets/images/profile.png";
import {getUserProfile} from "../../helpers/fakebackend_helper";
import {getLocalDateTime} from "../../helpers/component_helpers";
import moment from "moment-timezone";
import {getSpecificServices, postSetMaintenanceByServiceID} from "../../store/service/actions";
import OrgMaintenanceModal from "./OrgMaintenanceModal";
import googleIcon from "../../assets/images/google.svg";
import oktaIcon from "../../assets/images/Okta_logo.svg";

const Organization = (props) => {
  //meta title
  document.title = "Organization Profile | Temperstack";

  const dispatch = useDispatch();

  const [defaultRoles, setRoles] = useState([]);
  const [unmappedServices, setUnmappedServices] = useState([]);
  const [nonTeamMembers, setNonTeamMembers] = useState([])
  const [roleOptionGroup, setRoleOptionGroup] = useState([]);
  const [notifChannels, setNotifChannels] = useState([]);
  const [notifChannelOptionGroup, setNotifChannelOptionGroup] = useState([]);
  const [selectedNotifChannel, setSelectedNotifChannel] = useState(null);
  const [allowedDomainRestrictions, setAllowedDomainRestrictions] = useState([]);
  const [addNewDomainRestriction, setNewDomainRestriction] = useState('');
  const [getSsoOnlyLogin, setGetSsoOnlyLogin] = useState(false);
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [publishStatusPage, setpublishStatusPage] = useState(false);
  const [resourceCountDaily, setResourceCountDaily] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const itemsPerPage = 20;
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showStatusPageModal, setShowStatusPageModal] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentUserId = localStorage.getItem("user_id");

  const tab = ["1", "2", "3", "4", "5", "6"].includes(queryParams.get('tab')) ? queryParams.get('tab') : null;
  const [activeTab, setActiveTab] = useState(tab || "1");

  const navigate = useNavigate();
  const handleTabChange = (newTab) => {
    // setActiveTab(newTab);

    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', newTab);

    navigate({
      pathname: location.pathname,
      search: searchParams.toString()
    }, {replace: true});
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab');
  }, [location.search]);

  const {users, organizationDetail, subscriptionDetail} = useSelector(state => ({
    users: state.Organization.users || [],
    organizationDetail: state.Organization.organization || [],
    subscriptionDetail: state.Organization.subscription || []
  }));

  const {roles} = useSelector(state => ({
    roles: state.Organization.roles || []
  }))

  const {allowedDomains} = useSelector(state => ({
    allowedDomains: state.Organization.allowed_domain_restrictions || []
  }))

  const {bluejayTeams} = useSelector(state => ({
    bluejayTeams: state.Organization.bluejay_teams || []
  }))

  const {services} = useSelector(state => ({
    services: state.Organization.services || []
  }))

  const {nonTeamUsers} = useSelector(state => ({
    nonTeamUsers: state.Organization.non_team_members || []
  }))

  const {orgPrimaryNotifChannels} = useSelector(state => ({
    orgPrimaryNotifChannels: state.Organization.org_primary_notif_channels || []
  }))

  const {ssoOnlyLoginStatus} = useSelector(state => ({
    ssoOnlyLoginStatus: state.Organization.get_sso_only_login || {}
  }))

  const {toggleSsoOnlyLoginStatus} = useSelector(state => ({
    toggleSsoOnlyLoginStatus: state.Organization.toggle_sso_only_login || {}
  }))

  const {scanCount} = useSelector(state => ({
    scanCount: state.Organization.resourceScanCount || {}
  }))

  const {alertsCount} = useSelector(state => ({
    alertsCount: state.Organization.alertsCount || {}
  }))

  const {dailyResourceCount} = useSelector(state => ({
    dailyResourceCount: state.Organization.dailyResourceCount || {}
  }))

  const {monthlyResourceCount} = useSelector(state => ({
    monthlyResourceCount: state.Organization.monthlyResourceCount || {}
  }))

  const {paginatedUsers} = useSelector(state => ({
    paginatedUsers: state.Organization.paginatedUsers || []
  }));

  const {usersCount} = useSelector(state => ({
    usersCount: state.Organization.usersCount || 0
  }));

  const { changeEvents,changeEventWebhooks,changeEventById,createEventWebhook } = useSelector(state => ({
    changeEvents: state.Organization.changeEvents || [],
    changeEventWebhooks: state.Organization.changeEventWebhooks || [],
    changeEventById: state.Organization.changeEventById || [],
    createEventWebhook: state.Organization.createEventWebhook || []
  }));

  const currentUserRole = users.find(user => user.id === currentUserId)?.role?.name || null;
  const totalUsers = usersCount?.count || 0;
  const totalPages = Math.ceil(totalUsers / itemsPerPage);

  let startPage = Math.max(selectedPage - 1, 1);
  let endPage = Math.min(startPage + 2, totalPages);
  if (endPage === totalPages) {
    startPage = Math.max(totalPages - 2, 1);
  }


  useEffect(() => {
    if (!isSearching) {
      const payload = {
        page: selectedPage,
        limit: itemsPerPage,
        searchTerm: searchTerm || null,
      };
      dispatch(onGetPaginatedUsers(payload));
      dispatch(onGetUsersCount(payload));
    }
  }, [dispatch, selectedPage, searchTerm]);

  const handlePageClick = (pageNumber) => {
    setSelectedPage(pageNumber);
    const payload = {
      page: pageNumber,
      limit: itemsPerPage,
      searchTerm: searchTerm || null,
    };
    dispatch(onGetPaginatedUsers(payload));
  };

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setIsSearching(term.length > 0);

  }
  const handleSearchSubmit = () => {
    const payload = {
      page: selectedPage,
      limit: itemsPerPage,
      searchTerm: searchTerm || null,
    };
    dispatch(onGetPaginatedUsers(payload));
    dispatch(onGetUsersCount(payload));
  };

  const displayUsers = paginatedUsers;
  useEffect(() => {
    dispatch(onGetUsers());
    dispatch(onGetPaginatedUsers());
  }, [dispatch, users, displayUsers]);

  useEffect(() => {
    let initialMonthlyCount = 0;
    let initialDailyCount = 0;
    Object.values(dailyResourceCount).forEach((resource) => {
      Object.values(resource).forEach((count) => {
        initialDailyCount += count;
      });
    });
    setResourceCountDaily(initialDailyCount);
  }, [dailyResourceCount]);

  useEffect(() => {
    setTwoFactorEnabled(organizationDetail?.two_factor_default);
    setpublishStatusPage(organizationDetail?.is_status_page_enabled);
  }, [organizationDetail]);

  useEffect(() => {
    let domains = []

    if (allowedDomains && allowedDomains.allowed_email_domains)
      domains = allowedDomains.allowed_email_domains

    setAllowedDomainRestrictions(domains);
  }, [allowedDomains]);

  useEffect(() => {
    setUnmappedServices(services);
  }, [services]);

  useEffect(() => {
    let sso_only = false

    if (ssoOnlyLoginStatus && ssoOnlyLoginStatus.sso_only_login)
      sso_only = ssoOnlyLoginStatus.sso_only_login

    setGetSsoOnlyLogin(sso_only)

  }, [ssoOnlyLoginStatus]);

  useEffect(() => {
    dispatch(onGetSsoOnlyLogin());
  }, [toggleSsoOnlyLoginStatus]);

  useEffect(() => {
    setNonTeamMembers(nonTeamUsers)
  }, [nonTeamUsers])

  useEffect(() => {
    setNotifChannels(orgPrimaryNotifChannels);
  }, [orgPrimaryNotifChannels]);

  const [isLoading, setIsLoading] = useState(false);
  const [action, setAction] = useState(null);
  const [selectedGroup, setselectedGroup] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedServices, setSelectedServices] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState(null);
  const [tooltip, setTooltip] = useState(false);
  const [tooltip2, setTooltip2] = useState(false);

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup);
  }

  function handleSelectRole(selectedRole) {
    setSelectedRole(selectedRole);
  }

  function handleChangeNotifChannel(changedNotifChannel) {
    if (selectedNotifChannel.label !== changedNotifChannel.label) {
      dispatch(onUpdateOrgPrimaryNotificationChannels(changedNotifChannel.value));
    }
  }

  function handleSelectServices(selectedServices) {
    setSelectedServices(selectedServices);
  }

  function handleSelectUsers(selectedUsers) {
    setSelectedUsers(selectedUsers)
  }

  useEffect(() => {
    setRoles(roles);
  }, [roles]);

  const optionGroup = [
    {
      label: "Country Code",
      options: countryCodes
    },
  ];

  useEffect(() => {
    if (defaultRoles) {
      const roles = defaultRoles.map(role => ({value: role.id, label: role.name}));
      setRoleOptionGroup(roles);

      const defaultRole = roles.find(role => role.label === 'User');
      if (defaultRole) {
        setSelectedRole(defaultRole);
      }
    }
  }, [defaultRoles]);

  useEffect(() => {
    if (notifChannels) {
      const channels = notifChannels.map(channel => ({
        value: channel.id,
        label: channel.name === 'Email' ? 'Temperstack' : channel.name
      }));
      setNotifChannelOptionGroup(channels);

      // find the primary notification channel
      const primaryChannel = notifChannels.find(channel => channel.is_primary === true);
      if (primaryChannel) {
        setSelectedNotifChannel({
          value: primaryChannel.id,
          label: primaryChannel.name === 'Email' ? 'Temperstack' : primaryChannel.name
        });
      }
    }
  }, [notifChannels]);


  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      handleTabChange(tab);
    }
  };

  useEffect(() => {
    dispatch(onGetAllowedDomainRestrictions());
  }, [onGetAllowedDomainRestrictions]);


  useEffect(() => {
    dispatch(onGetUsers());
    dispatch(onGetOrganization());
    dispatch(onGetSubscription());
    dispatch(onGetAlertDeploymentCount());
    dispatch(onGetResourceScanCount());
    dispatch(onGetDailyResourceCount());
    dispatch(onGetMonthlyResourceCount());
  }, [onGetUsers,
    onGetOrganization,
    onGetSubscription,
    onGetAlertDeploymentCount,
    onGetResourceScanCount,
    onGetDailyResourceCount,
    onGetMonthlyResourceCount]);

  useEffect(() => {
    dispatch(onGetRoles());
  }, [onGetRoles])

  useEffect(() => {
    dispatch(onGetBluejayTeam());
  }, [onGetBluejayTeam])

  useEffect(() => {
    dispatch(onGetOrgPrimaryNotificationChannels());
  }, [onGetOrgPrimaryNotificationChannels])

  useEffect(() => {
    dispatch(onGetSsoOnlyLogin());
  }, [onGetSsoOnlyLogin]);

  const startLoading = () => {
    setIsLoading(current => !current);
  };

  const endLoading = () => {
    setIsLoading(current => !current);
  };

  const [currentUsers, setCurrentUsers] = useState([]);

  useEffect(() => {
    setCurrentUsers(users);
  }, [users]);

  const handleFormChange = (index, event, user_id) => {
    //Ignore the default value
    if (event.target.value === "") {
      return;
    }
    const role_id = event.target.value
    dispatch(onUpdateRoles(user_id, role_id));
  }

  const toggleSsoOnlyLogin = () => {
    dispatch(onToggleSsoOnlyLogin());
  }

  const toggleTwoFactorAuthentication = () => {
    let payload = {"org_id": organizationDetail?.id};
    const newTwoFactorState = !twoFactorEnabled;
    dispatch(updateTwoFactorOrgEnabled(payload));
    setTwoFactorEnabled(newTwoFactorState);
    if (newTwoFactorState) {
      showNotification("success", "Two-Factor Authentication has been successfully enabled for all users across the organization.");
    } else {
      showNotification("success", "Two-Factor Authentication has been successfully disabled for the organization.");
    }
  }

  const togglePublishStatusPageState = () => {
    const newTwoFactorState = !publishStatusPage;
    setShowStatusPageModal(true);
    setpublishStatusPage(newTwoFactorState);
  }

  const OffSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: '',
      name: '',
      phoneNumber: '',
    },
    validate: (values) => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Please enter the email address';
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = 'Invalid email address';
      }
      return errors;
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please enter the email address"),
      name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
        .test('not-only-spaces', 'Name cannot be only spaces', value => {
          return value && value.trim().length > 0;
        })
        .required("Please enter the name"),
      phoneNumber: Yup.string()
        .matches(/^[0-9]+$/, 'Phone number should contain only numbers')
        .required('Please enter the phone number'),
    }),
    onSubmit: async (values, {resetForm}) => {
      try {
        // await dispatch(onInviteUser(values.email, values.name, values.phoneNumber));
        setTimeout(async () => {
          try {
            const fullPhoneNumber = selectedGroup.value + values.phoneNumber;
            const role_id = selectedRole.value;
            await dispatch(onInviteUser(values.email, values.name.trim(), fullPhoneNumber, role_id));
          } catch (error) {
            console.error('Error:', error);
          } finally {
            endLoading();
            resetForm({
              email: '',
              name: '',
              phoneNumber: '',
            });
            setselectedGroup(null);
            setSelectedRole(null);
          }
        }, 4000);
      } catch (error) {
        console.error('Error:', error);
      }
      // finally{
      //   endLoading();
      // }
    },
  });
  const [userForEdit, setUserForEdit] = useState(null)
  const editValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      phoneNumber: ''
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
        .test('not-only-spaces', 'Name cannot be only spaces', value => {
          return value && value.trim().length > 0;
        })
        .required("Please enter the name"),
      phoneNumber: Yup.string()
        .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
        .required('Please enter the phone number'),
    }),
    onSubmit: async (values) => {
      try {
        setTimeout(async () => {
          try {
            const payload = {};
            const trimmedName = values.name.trim();
            if (trimmedName !== userForEdit.name) {
              payload.name = trimmedName;
            }
            const fullPhoneNumber = editSelectedGroup.value + values.phoneNumber;
            if (fullPhoneNumber !== userForEdit.phone_number) {
              payload.phone_number = fullPhoneNumber;
            }
            if (Object.keys(payload).length > 0) {
              await dispatch(onUpdateUser({user_id: userForEdit.id, ...payload}));
            }
            setUserEditModal(false);
            setUserForEdit(null);
            setEditSelectedGroup(null);
          } catch (error) {
            console.error('Error:', error);
          }
        }, 4000);
      } catch (error) {
        console.error('Error:', error);
      }
    },
  });

  const billingValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      billingEmail: organizationDetail?.billing_email || '',
      billingName: organizationDetail?.billing_name || '',
      billingAddress: organizationDetail?.address || '',
      billingCity: organizationDetail?.city || '',
      billingCountry: organizationDetail?.country || '',
      billingState: organizationDetail?.state || '',
      billingZipCode: organizationDetail?.zip_code || '',
    },
    validate: (values) => {
      const errors = {};
      if (!values.billingEmail) {
        errors.billingEmail = 'Please enter the email address';
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.billingEmail)
      ) {
        errors.billingEmail = 'Invalid email address';
      }
      return errors;
    },
    validationSchema: Yup.object({
      billingEmail: Yup.string().required("Please enter the email address"),
      billingName: Yup.string().required("Please enter the name"),
      billingAddress: Yup.string().required("Please enter the full billing address"),
      billingCity: Yup.string().required("Please enter the city"),
      billingCountry: Yup.string().required("Please enter the country"),
      billingState: Yup.string().required("Please enter the state"),
      billingZipCode: Yup.string().required("Please enter the zip code"),
    }),
    onSubmit: async (values) => {
      try {
        await dispatch(onUpdateBillingDetails(values.billingName, values.billingEmail, values.billingAddress, values.billingCity, values.billingCountry, values.billingState, values.billingZipCode));
      } catch (error) {
        console.error('Error:', error);
      }
    },
  });


  const teamValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter the team name"),
    }),
    onSubmit: async (values) => {
      try {
        await dispatch(onCreateBluejayTeam(values.name));
      } catch (error) {
        console.error('Error:', error);
      }
    },
  });

  useEffect(() => {
    const isFormDirty = billingValidation.dirty;
    const submitButton = document.querySelector("#editBillingButton");
    if (submitButton) {
      submitButton.disabled = !isFormDirty;
    }
  }, [billingValidation.dirty]);

  const handleResendInvite = async (useremail, username, phoneNumber, role_id) => {
    try {
      setTimeout(async () => {
        try {
          await dispatch(onInviteUser(useremail, username, phoneNumber, role_id));
        } catch (error) {
          console.error('Error:', error);
        } finally {
          endLoading();
        }
      }, 4000);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const handleUserDelete = async (user_id) => {
    try {
      setTimeout(async () => {
        try {
          await dispatch(onDeleteUser(user_id));
          setUserDeleteModal(false);
          setUserForDelete(null);
        } catch (error) {
          console.error('Error:', error);
        } finally {
          endLoading();
        }
      }, 4000);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [UserDeleteModal, setUserDeleteModal] = useState(false);
  const [userForDelete, setUserForDelete] = useState(null);
  const [userEditModal, setUserEditModal] = useState(false);
  const [addUserModal, setAddUserModal] = useState(false);
  const [mapServiceModal, setMapServiceModal] = useState(false);
  const [teamToUpdate, setTeamToUpdate] = useState(null);
  const [isDisplayMappedServicesModalOpen, setIsDisplayMappedServicesModalOpen] = useState(false);
  const [currentTeamServices, setCurrentTeamServices] = useState([]);
  const [isDisplayUsersModalOpen, setIsDisplayUsersModalOpen] = useState(false);
  const [currentTeamUsers, setCurrentTeamUsers] = useState([]);
  const [editSelectedGroup, setEditSelectedGroup] = useState(null);
  const [maintenanceModal, setMaintenanceModal] = useState(false);
  const [profilePicModal, setProfilePicModal] = useState(false);
  const [data, setData] = useState(null);
  const [statusPageIoMigrationDetails, setStatusPageIoMigrationDetails] = useState({
    api_key: '',
    page_id: '',
  });
  const [servicesTooltip, setServicesTooltip] = useState(false);

  const cancelUserDeleteModal = () => {
    setUserDeleteModal(current => !current);
    setUserForDelete(null)
  }

  const handleUserDeleteModal = (user) => {
    setUserDeleteModal(current => !current);
    setUserForDelete(user)
  }

  const cancelUserEditModal = () => {
    setUserEditModal(current => !current);
    setUserForEdit(null);
    setEditSelectedGroup(null);
    editValidation.resetForm();
  };

  const handleUserEditModal = (user) => {
    setUserEditModal(current => !current);
    setUserForEdit(user);
    if (user.phone_number) {
      let len = user.phone_number.length;
      let number = user.phone_number.substr(len - 10, len);
      let number_code = user.phone_number.substr(0, len - 10);
      const code_label = countryCodes.find(code => code.value === number_code);
      setEditSelectedGroup(code_label);

      editValidation.setValues({
        name: user.name,
        phoneNumber: number
      });
    } else {
      editValidation.setValues({
        name: user.name,
        phoneNumber: ''
      });
    }
  };

  const cancelAddUserModal = () => {
    setAddUserModal(current => !current);
    setNonTeamMembers([])
    setTeamToUpdate(null)
    setSelectedUsers(null)
  }

  const handleAddUserModal = (team) => {
    setAddUserModal(current => !current);
    dispatch(onNonTeamUsers(team.id))
    setTeamToUpdate(team);
  }

  const cancelMapServiceModal = () => {
    setMapServiceModal(current => !current);
    setUnmappedServices([])
    setTeamToUpdate(null)
    setSelectedServices(null)
  }

  const closeIsMappedServices = () => {
    setIsDisplayMappedServicesModalOpen(current => !current);
    setCurrentTeamServices([])
    setTeamToUpdate(null)
  }

  const closeTeamUsers = () => {
    setIsDisplayUsersModalOpen(current => !current);
    setCurrentTeamUsers([])
    setTeamToUpdate(null);
  }

  const handleMapServiceModal = (team) => {
    setMapServiceModal(current => !current);
    dispatch(onGetUnmappedServices(team.id))
    setTeamToUpdate(team);
  }

  const handleAddUser = (teamId) => {

    if (selectedUsers !== null && selectedUsers.length > 0) {
      let user_ids = []

      for (let i = 0; i < selectedUsers.length; i++) {
        user_ids.push(selectedUsers[i].value);
      }

      dispatch(onAddUsersToTeam(teamId, user_ids));
    }

    setAddUserModal(false);
    setTeamToUpdate(null);
    setNonTeamMembers([])
    setSelectedUsers(null)
  }

  const handleMapService = (teamId) => {

    if (selectedServices !== null && selectedServices.length > 0) {

      let service_ids = []

      for (let i = 0; i < selectedServices.length; i++) {
        service_ids.push(selectedServices[i].value);
      }

      dispatch(onMapServicesToTeam(teamId, service_ids));

    }

    setMapServiceModal(false);
    setTeamToUpdate(null);
    setUnmappedServices([])
    setSelectedServices(null)
  }

  function formatDate(dateString) {
    if (!dateString) return "";

    const dateObj = new Date(dateString);

    if (isNaN(dateObj)) {
      return "Invalid Date";
    }

    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();

    return `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year}`;
  }

  const handleRemoveServiceFromTeam = (serviceId) => {
    dispatch(onDeleteServiceFromTeam(serviceId));
    setIsDisplayMappedServicesModalOpen(false);
    setTeamToUpdate(null);
  }

  const handleRemoveRestrictAllowedDomains = (domain) => {
    dispatch(onDeleteAllowedDomainRestrictions(domain));
  }

  const postAllowedDomainsRestrictions = () => {

    if (addNewDomainRestriction === '') return

    dispatch(onPostAllowedDomainRestrictions(addNewDomainRestriction));
    setNewDomainRestriction('')
  }

  const handleRemoveUserFromTeam = (userId, teamId) => {
    dispatch(onRemoveUserFromTeam(teamId, userId));
    setIsDisplayUsersModalOpen(false);
    setTeamToUpdate(null);
  }

  function onUpdateProfilePic() {
    if (profilePicModal) {
      setProfilePicModal(false);
    } else {
      setProfilePicModal(true);
    }
  }

  const getUserData = async () => {
    const data = await getUserProfile();
    setData(data);
  }
  const profilePicToggle = () => {
    if (profilePicModal) {
      setProfilePicModal(false);
    } else {
      setProfilePicModal(true);
    }
  }

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position: "relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position: "relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      position: "absolute",
      background: '#382b42', // Background color of the dropdown menu
      zIndex: 999,
    }),
    singleValue: (provided) => ({
      ...provided,
      position: "relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };

  function updateStatusPageVisibility() {
    dispatch(togglePublishStatusPage());
    setShowStatusPageModal(false);
  }

  function cancelUpdate() {
    setShowStatusPageModal(false);
    setpublishStatusPage(organizationDetail?.is_status_page_enabled);
  }

  function toggleMaintenance() {
    const current_state = getMaintenanceState(organizationDetail?.maintenance_window_end);
    if (current_state) {
      const payload = {
        duration_in_minutes: -1
      }
      dispatch(postSetOrgMaintenance(payload));
    } else {
      toggleMaintenanceModal();
    }
  }

  function toggleMaintenanceModal() {
    if (maintenanceModal) {
      setMaintenanceModal(false);
    } else {
      setMaintenanceModal(true)
    }
  }

  function getMaintenanceState(maintenanceWindowEnd) {
    let currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentTime = moment().tz(currentTimeZone);
    const maintenanceEndMoment = moment(maintenanceWindowEnd).tz(currentTimeZone)
    return currentTime.isBefore(maintenanceEndMoment);
  }

  function handleChangeStatusPageDetails(value, type) {
    if (type === 'api_key') {
      setStatusPageIoMigrationDetails({...statusPageIoMigrationDetails, api_key: value});
    } else if (type === 'page_id') {
      setStatusPageIoMigrationDetails({...statusPageIoMigrationDetails, page_id: value});
    }
  }

  function migrateStatusPageIO() {
    if (statusPageIoMigrationDetails.api_key === '' || statusPageIoMigrationDetails.page_id === '') {
      showNotification("error", "Please provide both API Key and Page ID");
      return;
    }
    dispatch(postExternalPageDetails(statusPageIoMigrationDetails));
    setStatusPageIoMigrationDetails({api_key: '', page_id: ''});
  }


  const [selectedType, setSelectedType] = useState({ value: 'deployment', label: 'Deployment' });
  const [expandedWebhookId, setExpandedWebhookId] = useState(null);
  const [expandedEventId, setExpandedEventId] = useState(null);
  const [currentHoverItem, setCurrentHoverItem] = useState(null);
  const [formData, setFormData] = useState({name: ''});
  const [touched, setTouched] = useState({name: false});
  const [tooltipOpen, setTooltipOpen] = useState({});
  const codeRef = useRef(null);
  const urlRef = useRef(null);
  const [showWebhookModal, setShowWebhookModal] = useState(false);
  const [shouldRefreshWebhooks, setShouldRefreshWebhooks] = useState(false);

  useEffect(() => {
    dispatch(onGetChangeEventWebhooks());
    dispatch(onGetChangeEvents());
  }, [shouldRefreshWebhooks]);
  useEffect(() => {
    if (createEventWebhook && createEventWebhook.integration_api_key) {
      setFormData({ name: '' });
      setTouched({ name: false });
      setShowWebhookModal(true);
    }
  }, [createEventWebhook]);

  const handleCloseWebhookModal = () => {
    setShowWebhookModal(false);
    dispatch(resetCreateEventWebhook());
  };
  const typeOptions = [
    { value: 'deployment', label: 'Deployment' }
  ];

  const copyToClipboard = (textToCopy) => {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy)
            .then(() => showNotification('success','Copied!'))
            .catch(err => console.error('Could not copy text: ', err));
    } else {
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
            showNotification('success','Copied!')
        } catch (err) {
            console.error('Could not copy text: ', err);
        }
        document.body.removeChild(textarea);
    }
  };

  const handleCopyCode = () => {
    if (codeRef.current) {
      const textToCopy = codeRef.current.textContent || codeRef.current.innerText;
      copyToClipboard(textToCopy);
    }
  };
  
  const handleCopyUrl = () => {
    if (urlRef.current) {
      const textToCopy = urlRef.current.textContent || urlRef.current.innerText;
      copyToClipboard(textToCopy);
    }
  };
  const customSelectStyles = { //kept for further usage when we add multiple types of select
    control: (base) => ({
      ...base,
      background: 'None',
      borderColor: 'whitesmoke',
      '&:hover': {
        borderColor: 'whitesmoke'
      }
    }),
    menu: (base) => ({
      ...base,
      background: 'None',
    }),
    option: (base, state) => ({
      ...base,
      background: state.isFocused ? '#485EC4' : '#222736',
      color: 'white'
    }),
    singleValue: (base) => ({
      ...base,
      color: 'white'
    })
  };
  const handleBlur = (field) => {
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));
  };
  const handleInputChange = (field, value) => {
    const trimmedStart = value.replace(/^\s+/, '');
    setFormData(prev => ({
      ...prev,
      [field]: trimmedStart
    }));
  };

  const shouldShowValidation = (field) => {
    return touched[field] && (!formData[field] || formData[field].trim() === '');
  };

  const handleWebhookSubmit = (e) => {
    e.preventDefault();
    setTouched({
      name: true
    });
    const finalValue = formData.name.trim();
    if (!finalValue) {
      return;
    }
  
    dispatch(onCreateChangeEventWebhook({
      integration_name: finalValue
    }));
    setShouldRefreshWebhooks(prev => !prev);
  };

  const toggleWebhookExpansion = (webhookId) => {
    setExpandedWebhookId(expandedWebhookId === webhookId ? null : webhookId);
    setExpandedEventId(null);
  };

  const toggleEventExpansion = (eventId, e) => {
    e.stopPropagation();
    setExpandedEventId(expandedEventId === eventId ? null : eventId);
  };

  const toggleTooltip = (id) => {
    setTooltipOpen(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  useEffect(() => {
    dispatch(getOktaSSOIntegration());
  }, []);

  const {oktaIntegration} = useSelector(state => ({
    oktaIntegration: state.Organization.oktaIntegration || {}
  }))

  const [clientSecret, setClientSecret] = useState('');
  const [clientID, setClientID] = useState('');
  const [oktaOrgUrl, setOktaOrgUrl] = useState('');
  const [oktaIntegrationExists, setOktaIntegrationExists] = useState(false);
  const [editOktaIntegration, setEditOktaIntegration] = useState(false);

  useEffect(() => {
    if (oktaIntegration && oktaIntegration.client_id) {
      setClientID(oktaIntegration.client_id);
      setClientSecret(oktaIntegration.client_secret);
      setOktaOrgUrl(oktaIntegration.organization_url);
      setOktaIntegrationExists(true);
      setEditOktaIntegration(false)
    }else {
      setEditOktaIntegration(true);
    }
  }, [oktaIntegration]);


  function handleOktaSubmit() {
    if (!clientID?.trim() || !clientSecret?.trim() || !oktaOrgUrl?.trim()) {
      let missingFields = [];
      if (!clientID?.trim()) missingFields.push("Client ID");
      if (!clientSecret?.trim()) missingFields.push("Client Secret");
      if (!oktaOrgUrl?.trim()) missingFields.push("Okta Org URL");
      showNotification('error', `Please fill in the following fields: ${missingFields.join(", ")}`);
      return;
    }
    let payload = {
      client_id: clientID,
      client_secret: clientSecret,
      org_url: oktaOrgUrl,
      redirect_url : `${window.location.origin}/login`
    }
    dispatch(postCreateOktaSSOIntegration(payload));
  }

  function handleEditOktaIntegration() {
    setEditOktaIntegration(true);
    setClientID('')
    setClientSecret('')
    setOktaOrgUrl('')
  }

  const [ssoCollapse, setSsoCollapse] = useState({'okta': false,'google': false});

  function toggleCollapse(ssoType) {
    setSsoCollapse(prevState => ({
      ...prevState,
      [ssoType]: !prevState[ssoType]
    }));
  }

  return (
    <React.Fragment>
      <OrgMaintenanceModal
        isOpen={maintenanceModal}
        toggle={toggleMaintenanceModal}
      />
      <div className="page-content">
        <Container fluid className="w-100">
          <div>
            <Nav pills className="nav-custom">
              <NavItem className="nav-item-custom" style={{width: "16.66%"}}>
                <NavLink
                  className={classnames({
                    active: activeTab === "1",
                  })}
                  onClick={() => {
                    toggleTab("1");
                  }}
                >
                  <span className="d-sm-block">Organization Setting</span>
                </NavLink>
              </NavItem>
              <NavItem className="nav-item-custom" style={{width: "16.66%"}}>
                <NavLink
                  className={classnames({
                    active: activeTab === "2",
                  })}
                  onClick={() => {
                    toggleTab("2");
                  }}
                >
                  <span className="d-sm-block">Setup Teams</span>
                </NavLink>
              </NavItem>

              <NavItem className="nav-item-custom" style={{width: "16.66%"}}>
                <NavLink
                  className={classnames({
                    active: activeTab === "3",
                  })}
                  onClick={() => {
                    toggleTab("3");
                  }}
                >
                  <span className="d-sm-block">Manage Users</span>
                </NavLink>
              </NavItem>
              <NavItem className="nav-item-custom" style={{width: "16.66%"}}>
                <NavLink
                  className={classnames({
                    active: activeTab === "4",
                  })}
                  onClick={() => {
                    toggleTab("4");
                  }}
                >
                  <span className="d-sm-block">Configure Scan</span>

                </NavLink>
              </NavItem>
              <NavItem className="nav-item-custom" style={{width: "16.66%"}}>
                <NavLink
                  className={classnames({
                    active: activeTab === "5",
                  })}
                  onClick={() => {
                    toggleTab("5");
                  }}
                >
                  <span className="d-sm-block">Manage Auto Mapping</span>

                </NavLink>
              </NavItem>
              <NavItem className="nav-item-custom" style={{width: "16.66%"}}>
                <NavLink
                    className={classnames({
                      active: activeTab === "6",
                    })}
                    onClick={() => {
                      toggleTab("6");
                    }}
                >
                  <span className="d-sm-block">Integrate CI/CD</span>
                 
                </NavLink>
              </NavItem>
            </Nav>
            <hr style={{border: "1px solid #556ee6", backgroundColor: "#556ee6", width: "100%", marginTop: "-1px",}}/>
            <TabContent activeTab={activeTab} className="py-4">
              <TabPane tabId="1">
                <div>
                  <Row>
                    <Col md={6}>
                      <Card>
                        <CardBody>
                          <h5>Organization Details</h5>
                          <Form
                            className="form-horizontal mt-4"
                            onSubmit={(e) => {
                              e.preventDefault();
                              // startLoading();
                              if (billingValidation.isValid) {
                                billingValidation.handleSubmit();
                              } else {
                                alert("Please fill out all fields correctly.");
                                // endLoading();
                              }
                            }}
                          >
                            <div>
                              <table className="table-purple-org" style={{borderRadius: "10px"}}>
                                <tbody>
                                <tr>
                                  <td scope="col">Name of the organization</td>
                                  <td scope="col">{organizationDetail?.name}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Subdomain</td>
                                  <td scope="col">{organizationDetail?.domain}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Date of creation</td>
                                  <td scope="col">{formatDate(organizationDetail?.created_at)}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Billing Name</td>
                                  <td>
                                    <Input
                                      name="billingName"
                                      className="input"
                                      placeholder="Billing Name"
                                      type="text"
                                      required
                                      onChange={billingValidation.handleChange}
                                      onBlur={billingValidation.handleBlur}
                                      value={billingValidation.values.billingName || ""}
                                      invalid={
                                        billingValidation.touched.billingName && billingValidation.errors.billingName ? true : false
                                      }
                                    />
                                    {billingValidation.touched.billingName && billingValidation.errors.billingName && (
                                      <FormFeedback type="invalid">
                                        {billingValidation.errors.billingName}
                                      </FormFeedback>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="col">Billing Email ID</td>
                                  <td>
                                    <Input
                                      name="billingEmail"
                                      className="input"
                                      style={{border: "1px solid whitesmoke"}}
                                      placeholder="Billing EmailID"
                                      type="text"
                                      required
                                      onChange={billingValidation.handleChange}
                                      onBlur={billingValidation.handleBlur}
                                      value={billingValidation.values.billingEmail || ""}
                                      invalid={
                                        billingValidation.touched.billingEmail && billingValidation.errors.billingEmail ? true : false
                                      }
                                    />
                                    {billingValidation.touched.billingEmail && billingValidation.errors.billingEmail && (
                                      <FormFeedback type="invalid">
                                        {billingValidation.errors.billingEmail}
                                      </FormFeedback>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="col">Billing Address</td>
                                  <td>
                                    <Input
                                      name="billingAddress"
                                      className="input"
                                      style={{border: "1px solid whitesmoke"}}
                                      placeholder="Billing Address"
                                      type="text"
                                      required
                                      onChange={billingValidation.handleChange}
                                      onBlur={billingValidation.handleBlur}
                                      value={billingValidation.values.billingAddress || ""}
                                      invalid={
                                        billingValidation.touched.billingAddress && billingValidation.errors.billingAddress ? true : false
                                      }
                                    />
                                    {billingValidation.touched.billingAddress && billingValidation.errors.billingAddress && (
                                      <FormFeedback type="invalid">
                                        {billingValidation.errors.billingAddress}
                                      </FormFeedback>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="col">City</td>
                                  <td>
                                    <Input
                                      name="billingCity"
                                      className="input"
                                      style={{border: "1px solid whitesmoke"}}
                                      placeholder="City"
                                      type="text"
                                      required
                                      onChange={billingValidation.handleChange}
                                      onBlur={billingValidation.handleBlur}
                                      value={billingValidation.values.billingCity || ""}
                                      invalid={
                                        billingValidation.touched.billingCity && billingValidation.errors.billingCity ? true : false
                                      }
                                    />
                                    {billingValidation.touched.billingCity && billingValidation.errors.billingCity && (
                                      <FormFeedback type="invalid">
                                        {billingValidation.errors.billingCity}
                                      </FormFeedback>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="col">Country</td>
                                  <td>
                                    <Input
                                      name="billingCountry"
                                      className="input"
                                      style={{border: "1px solid whitesmoke"}}
                                      placeholder="Country"
                                      type="text"
                                      required
                                      onChange={billingValidation.handleChange}
                                      onBlur={billingValidation.handleBlur}
                                      value={billingValidation.values.billingCountry || ""}
                                      invalid={
                                        billingValidation.touched.billingCountry && billingValidation.errors.billingCountry ? true : false
                                      }
                                    />
                                    {billingValidation.touched.billingCountry && billingValidation.errors.billingCountry && (
                                      <FormFeedback type="invalid">
                                        {billingValidation.errors.billingCountry}
                                      </FormFeedback>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="col">State</td>
                                  <td>
                                    <Input
                                      name="billingState"
                                      className="input"
                                      style={{border: "1px solid whitesmoke"}}
                                      placeholder="State"
                                      type="text"
                                      required
                                      onChange={billingValidation.handleChange}
                                      onBlur={billingValidation.handleBlur}
                                      value={billingValidation.values.billingState || ""}
                                      invalid={
                                        billingValidation.touched.billingState && billingValidation.errors.billingState ? true : false
                                      }
                                    />
                                    {billingValidation.touched.billingState && billingValidation.errors.billingState && (
                                      <FormFeedback type="invalid">
                                        {billingValidation.errors.billingState}
                                      </FormFeedback>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="col">Zip Code</td>
                                  <td>
                                    <Input
                                      name="billingZipCode"
                                      className="input"
                                      style={{border: "1px solid whitesmoke"}}
                                      placeholder="Zip Code"
                                      type="text"
                                      required
                                      onChange={billingValidation.handleChange}
                                      onBlur={billingValidation.handleBlur}
                                      value={billingValidation.values.billingZipCode || ""}
                                      invalid={
                                        billingValidation.touched.billingZipCode && billingValidation.errors.billingZipCode ? true : false
                                      }
                                    />
                                    {billingValidation.touched.billingZipCode && billingValidation.errors.billingZipCode && (
                                      <FormFeedback type="invalid">
                                        {billingValidation.errors.billingZipCode}
                                      </FormFeedback>
                                    )}
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                            <Row className="mb-3">
                              <Col className="text-end">
                                <button className="btn btn-primary w-md" type="submit" id="editBillingButton"
                                        disabled={!billingValidation.dirty}>
                                  Edit Billing Details
                                </button>
                              </Col>
                            </Row>
                          </Form>
                        </CardBody>
                        <CardBody>
                          <CardTitle className="text-uppercase"><b>Maintenance</b></CardTitle>
                          <table className="table-purple-org">
                            <tbody className="table-dark">
                            {organizationDetail?.maintenance_window_end && getMaintenanceState(organizationDetail?.maintenance_window_end) &&
                              <tr>
                                <td className="w-50">Current Maintenance Window End</td>
                                <td className="w-50">
                                  {getLocalDateTime(organizationDetail?.maintenance_window_end)}
                                </td>
                              </tr>
                            }
                            <tr>
                              <td className="w-50">Enable Maintenance</td>
                              <td style={{display: `flex`, alignItems: `center`}}>
                                <Switch
                                  uncheckedIcon={<OffSymbol/>}
                                  checkedIcon={<OnSymbol/>}
                                  className="me-1 mb-sm-8"
                                  height={20}
                                  width={44}
                                  onColor="#34c38f"
                                  offColor="#f46a6a"
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 5px"
                                  onChange={(e) => toggleMaintenance(organizationDetail?.id)}
                                  checked={getMaintenanceState(organizationDetail?.maintenance_window_end)}
                                />
                              </td>
                            </tr>
                            </tbody>
                          </table>

                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Card>
                          <CardBody>
                            <h5>Subscription Details</h5>
                            <div className="table-responsive">
                              <table className="table-purple-org">
                                <tbody>
                                <tr>
                                  <td scope="col">Subscription Name</td>
                                  <td scope="col">{subscriptionDetail?.master_product_plan?.name}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Number of Resources</td>
                                  <td scope="col">{subscriptionDetail?.master_product_plan?.number_of_resources}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Number of Scans</td>
                                  <td scope="col">{subscriptionDetail?.master_product_plan?.number_of_scans}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Number of Deployments</td>
                                  <td
                                    scope="col">{subscriptionDetail?.master_product_plan?.number_of_alert_deployments}</td>
                                </tr>
                                <tr>
                                  <td scope="col"><b>Plan start
                                    date: </b> {formatDate(subscriptionDetail?.plan_start_date)}</td>
                                  <td scope="col"><b>Plan end date: </b> {formatDate(subscriptionDetail?.plan_end_date)}
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </CardBody>
                        </Card>
                      </Row>
                      <Row>
                        <Card>
                          <CardBody>
                            <h5>Temperstack Usage Details</h5>
                            <div className="table-responsive">
                              <table className="table-purple-org">
                                <tbody>
                                <tr>
                                  <td scope="col">Resources Managed</td>
                                  <td scope="col">{resourceCountDaily}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Number of Scans</td>
                                  <td scope="col">{alertsCount?.alertsCount?.resource_scan_count}</td>
                                </tr>
                                <tr>
                                  <td scope="col">Number of alerts deployed</td>
                                  <td scope="col">{alertsCount?.alertsCount?.alert_deployment_count}</td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </CardBody>
                        </Card>
                        {/*<Card style={{height:'100%'}}>*/}
                        {/*    <CardBody className="px-1">*/}
                        {/*        <h5>Organisation Logo</h5>*/}
                        {/*        <div className="table-responsive">*/}
                        {/*            <table className="table-purple-org" style={{ marginBottom: "0", marginTop:"4.8%" }}>*/}
                        {/*                <tbody>*/}
                        {/*                    <tr>*/}
                        {/*                        <td scope="col" style={{*/}
                        {/*                            width: "50%",*/}
                        {/*                            verticalAlign: "middle",*/}
                        {/*                            paddingBottom: "3%",*/}
                        {/*                            fontSize: "13px",*/}
                        {/*                        }}>*/}
                        {/*                            Add/Update Organisation Logo:*/}
                        {/*                        </td>*/}
                        {/*                        <td scope="col" style={{*/}
                        {/*                            padding: "5px",*/}
                        {/*                            verticalAlign: "middle"*/}
                        {/*                        }}>*/}
                        {/*                            <OnUpdateProfilePicModal*/}
                        {/*                                isOpen={profilePicModal}*/}
                        {/*                                toggle={profilePicToggle}*/}
                        {/*                                userEmail={data?.email}*/}
                        {/*                                page="Organization"*/}
                        {/*                            />*/}
                        {/*                            <div className="d-flex justify-content-center">*/}
                        {/*                                <div*/}
                        {/*                                    className="position-relative"*/}
                        {/*                                    style={{*/}
                        {/*                                        width: "150px",*/}
                        {/*                                        height: "150px",*/}
                        {/*                                        display: "flex",*/}
                        {/*                                        justifyContent: "center",*/}
                        {/*                                        alignItems: "center"*/}
                        {/*                                    }}*/}
                        {/*                                >*/}
                        {/*                                    {organizationDetail?.logo ? (*/}
                        {/*                                        <img*/}
                        {/*                                            src={organizationDetail.logo}*/}
                        {/*                                            alt="Profile"*/}
                        {/*                                            style={{*/}
                        {/*                                                maxWidth: "150px",*/}
                        {/*                                                maxHeight: "150px",*/}
                        {/*                                                objectFit: "contain"*/}
                        {/*                                            }}*/}
                        {/*                                        />*/}
                        {/*                                    ) : organizationDetail?.name ? (*/}
                        {/*                                        <InitialsAvatar*/}
                        {/*                                            name={organizationDetail?.name}*/}
                        {/*                                            dimensions="110px"*/}
                        {/*                                            id="TooltipTop"*/}
                        {/*                                            style={{*/}
                        {/*                                                width: "120px",*/}
                        {/*                                                height: "120px",*/}
                        {/*                                                display: "flex",*/}
                        {/*                                                justifyContent: "center",*/}
                        {/*                                                alignItems: "center",*/}
                        {/*                                            }}*/}
                        {/*                                        />*/}
                        {/*                                    ) : (*/}
                        {/*                                        <img*/}
                        {/*                                            src={profileImg}*/}
                        {/*                                            alt="Default Profile"*/}
                        {/*                                            style={{*/}
                        {/*                                                width: "150px",*/}
                        {/*                                                height: "150px",*/}
                        {/*                                                objectFit: "contain"*/}
                        {/*                                            }}*/}
                        {/*                                        />*/}
                        {/*                                    )}*/}
                        {/*                                    <div className={organizationDetail?.logo ? "position-absolute bottom-0 end-0 mb-4" : "position-absolute bottom-0 end-0 mb-4 pe-3"}>*/}
                        {/*                                        <Link*/}
                        {/*                                            className="text-success p-1"*/}
                        {/*                                            onClick={() => onUpdateProfilePic()}*/}
                        {/*                                        >*/}
                        {/*                                            <div className="bg-white px-1 rounded-circle">*/}
                        {/*                                                <i*/}
                        {/*                                                    className="mdi mdi-pencil font-size-12"*/}
                        {/*                                                    id="editProfilePictooltip"*/}
                        {/*                                                />*/}
                        {/*                                            </div>*/}
                        {/*                                            <UncontrolledTooltip*/}
                        {/*                                                placement="top"*/}
                        {/*                                                target="editProfilePictooltip"*/}
                        {/*                                            >*/}
                        {/*                                                Update Organization Logo*/}
                        {/*                                            </UncontrolledTooltip>*/}
                        {/*                                        </Link>*/}
                        {/*                                    </div>*/}
                        {/*                                </div>*/}
                        {/*                            </div>*/}
                        {/*                        </td>*/}
                        {/*                    </tr>*/}
                        {/*                </tbody>*/}
                        {/*            </table>*/}
                        {/*        </div>*/}
                        {/*    </CardBody>*/}
                        {/*</Card>*/}
                      </Row>
                    </Col>
                    <hr style={{
                      border: "1px solid #e0e0e0",
                      backgroundColor: "#e0e0e0",
                      width: "100%",
                      marginTop: "-1px",
                    }}/>
                    {/*<Col md={6}>*/}
                    {/*    <h3>Notification Channel Settings</h3>*/}
                    {/*    <Row>*/}
                    {/*        <Card zIndex='2'>*/}
                    {/*            <CardBody>*/}
                    {/*                <h5>Change Primary Notification Channel</h5>*/}
                    {/*                <div className="mb-3 custom-flex-item">*/}
                    {/*                    <Select*/}
                    {/*                        value={selectedNotifChannel}*/}
                    {/*                        onChange={(selectedValue) => {*/}
                    {/*                            handleChangeNotifChannel(selectedValue);*/}
                    {/*                        }}*/}
                    {/*                        options={notifChannelOptionGroup}*/}
                    {/*                        className="select2-selection"*/}
                    {/*                        required*/}
                    {/*                        theme={(theme) => ({*/}
                    {/*                            ...theme,*/}
                    {/*                            borderRadius: 0,*/}
                    {/*                            colors: {*/}
                    {/*                                ...theme.colors,*/}
                    {/*                                neutral0: '#222736',*/}
                    {/*                                neutral5: '#485EC4',*/}
                    {/*                                neutral10: '#485EC4',*/}
                    {/*                                neutral60: '#ffffff',*/}
                    {/*                                neutral70: '#ffffff',*/}
                    {/*                                neutral80: '#ffffff',*/}
                    {/*                                neutral90: '#ffffff',*/}
                    {/*                                primary: '#485EC4',*/}
                    {/*                            },*/}

                    {/*                        })*/}
                    {/*                        }*/}
                    {/*                        styles={customStyles}*/}
                    {/*                    />*/}
                    {/*                </div>*/}
                    {/*            </CardBody>*/}
                    {/*        </Card>*/}
                    {/*    </Row>*/}
                    {/*</Col>*/}
                    {/*<hr style={{*/}
                    {/*    border: "1px solid #e0e0e0",*/}
                    {/*    backgroundColor: "#e0e0e0",*/}
                    {/*    width: "100%",*/}
                    {/*    marginTop: "-1px",*/}
                    {/*}}/>*/}

                    <Col md={6}>
                      <h3>Status Page Settings</h3>
                      <Row>
                        <Card>
                          <CardBody>
                            <div className='mb-1'>
                              <h5>Publish your status page</h5>
                              <p>
                                If this is enabled then your status page will be public and accessible to everyone
                              </p>
                              <Switch
                                uncheckedIcon={<OffSymbol/>}
                                checkedIcon={<OnSymbol/>}
                                className="me-1 mb-sm-8 mb-2"
                                height={20}
                                width={44}
                                onColor="#34c38f"
                                offColor="#f46a6a"
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 5px"
                                onChange={() => togglePublishStatusPageState()}
                                checked={publishStatusPage}
                              />
                            </div>
                          </CardBody>
                        </Card>
                      </Row>
                    </Col>
                  </Row>
                  <hr style={{
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#e0e0e0",
                    width: "100%",
                    marginTop: "-1px",
                  }}/>
                  <Row>
                    <Col md={6}>
                      <Col lg="6" className="align-items-center">
                        <DocsTooltip
                          placement={'right'}
                          isOpen={servicesTooltip}
                          toggle={() => setServicesTooltip(!servicesTooltip)}
                          targetId={'serviceTooltip'}
                          multipleLinks={[{
                            linkText: "Migration of subscribers from Statuspage",
                            link: "https://docs.temperstack.com/temperstack/incident-analysis-and-communication/external-and-internal-service-status-pages/instruction-to-migrate-subscribers-from-statuspage"
                          }
                          ]}
                        />
                      </Col>
                      <h3>
                        Migrate subscribers from Statuspage
                        <span>
                        <i role="button" className="bx bx-help-circle font-size-18 mt-2 ms-2" id="serviceTooltip"/>
                        </span>
                      </h3>
                      <Row>
                        <Card>
                          <CardBody>
                            <Row className="mb-3">
                              <div>
                                Enter your Statuspage API Key
                                <Col>
                                  <Input
                                    type="text"
                                    placeholder="Enter Api Key"
                                    className="input w-50"
                                    style={{border: "1px solid whitesmoke"}}
                                    required
                                    onChange={(e) => {
                                      handleChangeStatusPageDetails(e.target.value, 'api_key')
                                    }}
                                    value={statusPageIoMigrationDetails.api_key || ""}
                                  />
                                </Col>
                              </div>
                            </Row>

                            <Row className="mb-3">
                              <div>
                                Enter your Statuspage Page ID
                                <Col>
                                  <Input
                                    type="text"
                                    placeholder="Enter page id"
                                    className="input w-50"
                                    style={{border: "1px solid whitesmoke"}}
                                    required
                                    onChange={(e) => {
                                      handleChangeStatusPageDetails(e.target.value, 'page_id')
                                    }}
                                    value={statusPageIoMigrationDetails.page_id || ""}
                                  />
                                </Col>
                              </div>
                            </Row>

                            <Row>
                              <Col>
                                <button
                                  className="btn btn-primary w-md"
                                  onClick={() => migrateStatusPageIO()}
                                >
                                  Migrate
                                </button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </TabPane>

              <TabPane tabId="2">
                <div>
                  <Card>
                    <CardBody>
                      <CardTitle className="text-uppercase align-items-center"><b>Create Team</b>
                        <span role="button">
                        <i className="bx bx-help-circle font-size-16 text-white ms-1 mt-1" id="teamTooltip"/>
                      </span>
                        <DocsTooltip
                          placement={'right'}
                          isOpen={tooltip2}
                          toggle={() => setTooltip2(!tooltip2)}
                          targetId={'teamTooltip'}
                          content={'Need help'}
                          linkText={'Creating a team?'}
                          link='https://docs.temperstack.com/temperstack/overview/integrating-temperstack-as-the-incident-management-tool#creating-a-new-team-adding-users-and-mapping-services-to-teams'
                        />
                      </CardTitle>
                      <Form
                        className="form-horizontal mt-4"
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (teamValidation.isValid) {
                            teamValidation.handleSubmit();
                            // setAction('invite');
                          } else {
                            alert("Please fill out all fields correctly.");
                          }
                        }}
                      >
                        <div className="mb-3">
                          <Label className="form-label">Team Name</Label>
                          <Input
                            name="name"
                            className="input"
                            style={{border: '1px solid whitesmoke'}}
                            placeholder="Enter team name"
                            type="text"
                            required
                            onChange={teamValidation.handleChange}
                            onBlur={teamValidation.handleBlur}
                            value={teamValidation.values.name || ""}
                            invalid={
                              teamValidation.touched.name && teamValidation.errors.name ? true : false
                            }
                          />
                          {teamValidation.touched.name && teamValidation.errors.name && (
                            <FormFeedback type="invalid">
                              {teamValidation.errors.name}
                            </FormFeedback>
                          )}
                        </div>
                        <Row className="mb-3">
                          <Col className="text-end">
                            <button className="btn btn-primary w-md" type="submit">
                              Create Team
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardBody>
                      <h5>Teams</h5>
                      <div className="table-responsive">
                        <table className="table-purple">
                          <thead>
                          <tr>
                            <th scope="col" style={{textAlign: 'center'}}>Team Name</th>
                            <th scope="col" style={{textAlign: 'center'}}>Services</th>
                            <th scope="col" style={{textAlign: 'center'}}>Users</th>
                            <th scope="col" style={{textAlign: 'center'}}>Map Services</th>
                            <th scope="col" style={{textAlign: 'center'}}>Add Users</th>
                            <th scope="col" style={{textAlign: 'center'}}>Delete Team</th>
                          </tr>
                          </thead>
                          <tbody>
                          {/*Loop Through Bluejay Teams and create row with team name and created_at */
                            bluejayTeams.map((team, index) => (
                              <tr key={index}>
                                <td scope="col" className="align-middle" style={{textAlign: 'center'}}>{team.name}</td>
                                <td scope="col" className="align-middle" style={{maxWidth: '300px'}}>
                                  {
                                    team?.services?.slice(0, 2).map((service, index) => (
                                      <span key={index} className="chip false flase" style={{backgroundColor: 'grey'}}>
                                          {service.name}
                                        <i
                                          className="mdi mdi-close-circle-outline"
                                          style={{marginLeft: '5px', cursor: 'pointer'}}
                                          onClick={() => handleRemoveServiceFromTeam(service.id)}
                                        />
                                        </span>
                                    ))
                                  }
                                  {team?.services?.length > 2 &&
                                    <span
                                      onClick={() => {
                                        setIsDisplayMappedServicesModalOpen(true);
                                        setCurrentTeamServices(team.services);
                                        setTeamToUpdate(team);
                                      }}
                                      style={{cursor: 'pointer'}}>
                                        <i className="mdi mdi-eye" style={{color: 'white'}}
                                           id={`mapped-services-${index}`}></i>
                                        <UncontrolledTooltip className={"fix-flicker"} placement="top" target={`mapped-services-${index}`}>
                                          View All
                                        </UncontrolledTooltip>
                                      </span>}

                                  {(<Modal
                                    isOpen={isDisplayMappedServicesModalOpen}
                                    role="dialog"
                                    autoFocus={true}
                                    keyboard={false}
                                    centered
                                    backdrop="static"
                                    data-toggle="modal"
                                  >
                                    <ModalHeader className="border-bottom-2">
                                      Services Mapped to Team {teamToUpdate?.name}
                                    </ModalHeader>
                                    <ModalBody>
                                      <Container fluid>
                                        <div style={{marginBottom: '20px'}}>
                                          {
                                            currentTeamServices.map((service, index) => (
                                              <span key={index} className="chip false flase" style={{backgroundColor: 'grey'}}>
                                                  {service.name}
                                                <i
                                                  className="mdi mdi-close-circle-outline"
                                                  style={{marginLeft: '5px', cursor: 'pointer'}}
                                                  onClick={() => handleRemoveServiceFromTeam(service.id)}
                                                />
                                                </span>
                                            ))
                                          }
                                        </div>

                                        <div className="row">
                                          <Col lg="6" className="text-left">
                                            <Link onClick={closeIsMappedServices} className="btn btn-secondary w-md">Close</Link>
                                          </Col>
                                        </div>
                                      </Container>
                                    </ModalBody>
                                  </Modal>)}
                                </td>
                                <td scope="col" className="align-middle" style={{maxWidth: '300px'}}>
                                  {
                                    team?.users?.slice(0, 2).map((user, index) => (
                                      <span key={index} className="chip false flase" style={{backgroundColor: 'grey'}}>
                                          {user.user.name}
                                        <i
                                          className="mdi mdi-close-circle-outline"
                                          style={{marginLeft: '5px', cursor: 'pointer'}}
                                          onClick={() => handleRemoveUserFromTeam(user.user.id, team.id)}
                                        />
                                        </span>
                                    ))
                                  }
                                  {team?.users?.length > 2 &&
                                    <span
                                      onClick={() => {
                                        setIsDisplayUsersModalOpen(true);
                                        setCurrentTeamUsers(team);
                                        setTeamToUpdate(team);
                                      }}
                                      style={{cursor: 'pointer'}}>
                                        <i className="mdi mdi-eye" style={{color: 'white'}}
                                           id={`mapped-users-${index}`}></i>
                                        <UncontrolledTooltip className={"fix-flicker"} placement="top" target={`mapped-users-${index}`}>
                                          View All
                                        </UncontrolledTooltip>
                                      </span>
                                  }
                                  {(<Modal
                                    isOpen={isDisplayUsersModalOpen}
                                    role="dialog"
                                    autoFocus={true}
                                    keyboard={false}
                                    centered
                                    backdrop="static"
                                    data-toggle="modal"
                                  >
                                    <ModalHeader className="border-bottom-2">
                                      Users in Team {teamToUpdate?.name}
                                    </ModalHeader>
                                    <ModalBody>
                                      <Container fluid>
                                        <div style={{marginBottom: '20px'}}>
                                          {
                                            currentTeamUsers?.users?.map((user, index) => (
                                              <span key={index} className="chip false flase" style={{backgroundColor: 'grey'}}>
                                                  {user.user.name}
                                                <i
                                                  className="mdi mdi-close-circle-outline"
                                                  style={{marginLeft: '5px', cursor: 'pointer'}}
                                                  onClick={() => handleRemoveUserFromTeam(user.user.id, teamToUpdate.id)}
                                                />
                                                </span>
                                            ))
                                          }
                                        </div>

                                        <div className="row">
                                          <Col lg="6" className="text-left">
                                            <Link onClick={closeTeamUsers} className="btn btn-secondary w-md">Close</Link>
                                          </Col>
                                        </div>
                                      </Container>
                                    </ModalBody>
                                  </Modal>)}
                                </td>
                                <td scope="col" className="align-middle" style={{textAlign: 'center'}}>
                                  <Link
                                    to="#"
                                    className="btn btn-primary w-md"
                                    onClick={() => {
                                      handleMapServiceModal(team)
                                    }}
                                  >
                                    Map Services
                                  </Link>
                                </td>
                                <td scope="col" className="align-middle" style={{textAlign: 'center'}}>
                                  <Link
                                    to="#"
                                    className="btn btn-primary w-md"
                                    onClick={() => {
                                      handleAddUserModal(team)
                                    }}
                                  >
                                    Add Users
                                  </Link>
                                </td>
                                <td scope="col" className="align-middle" style={{textAlign: 'center'}}>
                                  {/* create a button to delete the team */}
                                  {team.name !== "Bluejay Default" && (
                                    <div
                                      className=" mx-auto"
                                      style={{cursor: 'pointer'}}
                                      onClick={() => {
                                        dispatch(onDeleteBluejayTeam(team.id));
                                      }}>
                                      <i className="mdi mdi-24px mdi-delete deleteUserIcon"></i>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))
                          }
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>

                </div>
              </TabPane>

              <TabPane tabId="3">
                <div>
                  <Row>
                    <Card zIndex="2">
                      <CardBody>
                        <CardTitle className="d-flex text-uppercase align-items-center"><b>Invite User</b>
                          <span id='inviteTooltip' className="d-flex ms-1 align-items-center" role="button">
                            <i className="bx bx-help-circle font-size-15 text-white"/>
                          </span>
                          <DocsTooltip
                            placement={'right'}
                            isOpen={tooltip}
                            toggle={() => setTooltip(!tooltip)}
                            targetId={'inviteTooltip'}
                            linkText={'inviting a user?'}
                            multipleLinks={[
                              {
                                linkText: 'Inviting a User',
                                link: 'https://docs.temperstack.com/temperstack/overview/integrating-temperstack-as-the-incident-management-tool#inviting-a-new-user'
                              },
                              {
                                linkText: 'Accepting invite',
                                link: 'https://docs.temperstack.com/temperstack/overview/integrating-temperstack-as-the-incident-management-tool#accepting-invite-as-a-new-user'
                              }
                            ]}
                          />
                        </CardTitle>
                        <Form
                          className="form-horizontal mt-4"
                          onSubmit={(e) => {
                            e.preventDefault();
                            startLoading();
                            if (validation.isValid) {
                              validation.handleSubmit();
                              setAction('invite');
                            } else {
                              alert("Please fill out all fields correctly.");
                              endLoading();
                            }
                          }}
                        >
                          <div className="mb-3">
                            <Label className="form-label">Name</Label>
                            <Input
                              name="name"
                              className="input"
                              style={{border: '1px solid whitesmoke'}}
                              placeholder="Name"
                              type="text"
                              required
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.name || ""}
                              invalid={
                                validation.touched.name && validation.errors.name ? true : false
                              }
                            />
                            {validation.touched.name && validation.errors.name && (
                              <FormFeedback type="invalid">
                                {validation.errors.name}
                              </FormFeedback>
                            )}
                          </div>
                          <div className="custom-flex-container">
                            <div className="mb-3 custom-flex-item">
                              <Label className="form-label">Email Id</Label>
                              <Input
                                name="email"
                                className="input"
                                style={{border: '1px solid whitesmoke'}}
                                placeholder="Official Email"
                                type="email"
                                required
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email && validation.errors.email ? true : false
                                }
                              />
                              {validation.touched.email && validation.errors.email && (
                                <FormFeedback type="invalid">
                                  {validation.errors.email}
                                </FormFeedback>
                              )}
                            </div>
                            <div className="mb-3 custom-flex-item">
                              <Label>Select Role</Label>
                              <Select
                                value={selectedRole}
                                onChange={(selectedValue) => {
                                  handleSelectRole(selectedValue);
                                }}
                                options={roleOptionGroup}
                                className="select2-selection"
                                required
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 0,
                                  colors: {
                                    ...theme.colors,
                                    neutral0: '#222736',
                                    neutral5: '#485EC4',
                                    neutral10: '#485EC4',
                                    neutral60: '#ffffff',
                                    neutral70: '#ffffff',
                                    neutral80: '#ffffff',
                                    neutral90: '#ffffff',
                                    primary: '#485EC4',
                                  },
                                })}
                                styles={customStyles}
                              />
                            </div>

                          </div>
                          <div className="custom-flex-container">
                            <div className="mb-3 custom-flex-item">
                              <Label>Select country code</Label>
                              <Select
                                value={selectedGroup}
                                onChange={(selectedValue) => {
                                  handleSelectGroup(selectedValue);
                                }}
                                options={optionGroup}
                                className="select2-selection"
                                required
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 0,
                                  colors: {
                                    ...theme.colors,
                                    neutral0: '#222736',
                                    neutral5: '#485EC4',
                                    neutral10: '#485EC4',
                                    neutral60: '#ffffff',
                                    neutral70: '#ffffff',
                                    neutral80: '#ffffff',
                                    neutral90: '#ffffff',
                                    primary: '#485EC4',
                                  },
                                })}
                                styles={customStyles}
                              />
                            </div>
                            <div className="mb-3 custom-flex-item">
                              <Label className="form-label">Phone Number</Label>
                              <Input
                                name="phoneNumber"
                                className="input"
                                style={{border: '1px solid whitesmoke'}}
                                placeholder="Phone Number"
                                type="tel"
                                required
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.phoneNumber || ""}
                                invalid={
                                  validation.touched.phoneNumber && validation.errors.phoneNumber ? true : false
                                }
                              />
                              {validation.touched.phoneNumber && validation.errors.phoneNumber && (
                                <FormFeedback type="invalid">
                                  {validation.errors.phoneNumber}
                                </FormFeedback>
                              )}
                            </div>
                          </div>
                          <Row className="mb-3">
                            <Col className="text-end">
                              <button className="btn btn-primary w-md" type="submit">
                                Invite User
                              </button>
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                    <Card zIndex={"1"}>
                      <CardBody>
                        <CardTitle className="text-uppercase"><b>Users</b></CardTitle>
                        <div className="d-flex justify-content-between mb-3 w-100 ">
                          <div className="d-inline-flex w-50">
                            <div className="w-45">
                              <Input
                                type="text"
                                placeholder="Search by Email"
                                value={searchTerm}
                                onChange={handleSearch}
                                onKeyDown={(e) => e.key === 'Enter' && handleSearchSubmit()}
                                className="me-2"
                                style={{width: "315px"}}
                              />
                            </div>
                            <div className="w-45">
                              <button type="button" className="btn btn-primary w-md" onClick={handleSearchSubmit}>
                                Submit
                              </button>
                            </div>
                          </div>
                          <div>
                            <Pagination aria-label="pagination navigation" listClassName="justify-content-end pagination-rounded" className="mb-3">
                              {totalPages > 1 && (
                                <PaginationItem key={Math.max(selectedPage - 1, 1)} disabled={selectedPage === 1}>
                                  <PaginationLink
                                    href="#"
                                    onClick={() => handlePageClick(Math.max(selectedPage - 1, 1))}
                                  >
                                    <i className="mdi mdi-chevron-left"/>
                                  </PaginationLink>
                                </PaginationItem>
                              )}
                              {[...Array(endPage - startPage + 1)].map((_, index) => (
                                <PaginationItem key={startPage + index} active={selectedPage === startPage + index}>
                                  <PaginationLink href="#" onClick={() => handlePageClick(startPage + index)}>
                                    {startPage + index}
                                  </PaginationLink>
                                </PaginationItem>
                              ))}
                              {totalPages > 1 && (
                                <PaginationItem key={Math.min(selectedPage + 1, totalPages)} disabled={selectedPage === totalPages}>
                                  <PaginationLink
                                    href="#"
                                    onClick={() => handlePageClick(Math.min(selectedPage + 1, totalPages))}
                                  >
                                    <i className="mdi mdi-chevron-right"/>
                                  </PaginationLink>
                                </PaginationItem>
                              )}
                            </Pagination>
                          </div>
                        </div>
                        <div className="table-responsive react-table">
                          <Table className="table-purple" hover>
                            <thead className="table-light table-nowrap" style={{textAlign: 'center', verticalAlign: 'middle'}}>
                            <tr>
                              <th className="text-white">Name</th>
                              <th className="text-white">Email</th>
                              <th className="text-white">Phone Number</th>
                              <th className="text-white">Invite Status</th>
                              <th className="text-white">Role</th>
                              <th className="text-white">2FA Enabled</th>
                              <th className="text-center text-white">Delete User</th>
                            </tr>
                            </thead>
                            <tbody style={{textAlign: 'center', verticalAlign: 'middle'}}>
                            {
                              displayUsers.length > 0 && displayUsers.map((user, index) => (
                                <tr key={index}>
                                  <td className="text-white">{user.name}</td>
                                  <td className="text-white">{user.email}</td>
                                  <td className="text-white">{user?.phone_number}</td>
                                  <td className="text-white">{user.email_verified ? 'Invite Accepted' : (
                                    <div>
                                      Invited
                                      <div>
                                        <Link
                                          to="#"
                                          key={index}
                                          onClick={() => {
                                            handleResendInvite(user.email, user.name, user.phone_number, user.role.id)
                                            setAction('reinvite');
                                            startLoading();
                                          }
                                          }>
                                          Resend invite
                                        </Link>
                                      </div>
                                    </div>
                                  )}</td>
                                  <td className="text-white">
                                    {user.id !== currentUserId ? (
                                      <div className="input">
                                        <select
                                          id="formrow-InputState"
                                          name="default_roles"
                                          className="custom_select"
                                          placeholder="Assign Role"
                                          value={user?.role?.id || ''}
                                          onChange={event => handleFormChange(index, event, user.id)}

                                        >
                                          <option className="text-black" value="">Select a role</option>
                                          {
                                            defaultRoles.map((role, index) => (
                                              <option className="text-black" key={index} value={role.id}>{role.name}</option>
                                            ))
                                          }

                                        </select>
                                      </div>
                                    ) : user?.role?.name}

                                  </td>
                                  <td className="text-white">
                                    {user?.is_two_factor_enabled ? 'Enabled' : 'Disabled'}
                                  </td>
                                  <td>
                                    {user.id === currentUserId ? (
                                      <div className="mx-auto">
                                        <Link to="/profile" className="text-success">
                                          <i className="mdi mdi-pencil font-size-20" id={`edittooltip-${index}`}/>
                                          <UncontrolledTooltip placement="top" target={`edittooltip-${index}`}>
                                            Edit
                                          </UncontrolledTooltip>
                                        </Link>
                                      </div>
                                    ) : (
                                      currentUserRole === "Admin" && (
                                        <div className="d-flex justify-content-center">
                                          <div
                                            className="mx-1 text-success"
                                            style={{cursor: 'pointer'}}
                                            onClick={() => handleUserEditModal(user)}
                                          >
                                            <i className="mdi mdi-pencil font-size-20" id={`edittooltip-${index}`}/>
                                            <UncontrolledTooltip placement="top" target={`edittooltip-${index}`}>
                                              Edit
                                            </UncontrolledTooltip>
                                          </div>
                                          <div
                                            className="m1-2"
                                            style={{cursor: 'pointer'}}
                                            onClick={() => handleUserDeleteModal(user)}
                                          >
                                            <i className="mdi font-size-22 mdi-delete deleteUserIcon"></i>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </td>
                                </tr>
                              ))
                            }
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  <h2>Advance Settings</h2>
                    <Col md={6}>
                      <Row>
                        <Card>
                          <CardBody>
                            <div className='mb-1'>
                              <h5>Enable Two Factor Authentication</h5>
                              <p>Enforces the use of 2FA across organization</p>
                              <Switch
                                uncheckedIcon={<OffSymbol/>}
                                checkedIcon={<OnSymbol/>}
                                className="me-1 mb-sm-8 mb-2"
                                height={20}
                                width={44}
                                onColor="#34c38f"
                                offColor="#f46a6a"
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 5px"
                                onChange={() => toggleTwoFactorAuthentication()}
                                checked={twoFactorEnabled}
                              />
                            </div>
                          </CardBody>
                        </Card>
                      </Row>
                    </Col>
                    <Row
                      className={'mb-2'}
                      onClick={(e) => toggleCollapse('google')}>
                        <Col style={{
                          width: "100%",
                          borderRadius:'5px',
                          backgroundColor: 'rgba(255, 255, 255, 0.05)',
                          backdropFilter: 'blur(10px)',
                          WebkitBackdropFilter: 'blur(10px)',
                          marginTop: "-1px",
                        }}>
                          <div className="p-2 d-flex align-items-center justify-content-between">
                            <h4 role="button" className="change-table-text d-flex gap-1 text-uppercase mt-1">
                              <img src={googleIcon} style={{height: "24px", color:"secondary"}}
                                   className="bx bxl-google me-2"/>
                              Google SSO Settings
                            </h4>
                            <i className="mdi mdi-chevron-down font-size-18"></i>
                          </div>
                        </Col>
                    </Row>
                    <Collapse isOpen={ssoCollapse.google}>
                      <Col md={6}>
                        <Row>
                          <Card zIndex="1">
                            <CardBody>
                              <h5>Login Email Domain Restriction</h5>
                              <p>Existing users from other email domains will not be restricted</p>
                              <p>If no email domains are provided then all email domains are allowed for SSO</p>
                              <Row className="mb-3">
                                <Col>
                                  <Input
                                    type="text"
                                    placeholder="Enter domain"
                                    className="input"
                                    style={{border: "1px solid whitesmoke"}}
                                    required
                                    onChange={(e) => {
                                      setNewDomainRestriction(e.target.value)
                                    }
                                    }
                                    value={addNewDomainRestriction}
                                  />
                                </Col>
                                <Col>
                                  <button className="btn btn-primary w-md" onClick={postAllowedDomainsRestrictions}>
                                    Add
                                  </button>
                                </Col>
                              </Row>
                              {allowedDomainRestrictions.map((domain, index) => (
                                <span key={index} className="chip false flase" style={{backgroundColor: 'grey'}}>
                                    {domain}
                                  <i
                                    className="mdi mdi-close-circle-outline"
                                    style={{marginLeft: '5px', cursor: 'pointer'}}
                                    onClick={() => handleRemoveRestrictAllowedDomains(domain)}
                                  />
                                  </span>
                              ))}
                              <div className='mt-3'>
                                <h5>Only Allow SSO Login</h5>
                                <Switch
                                  uncheckedIcon={<OffSymbol/>}
                                  checkedIcon={<OnSymbol/>}
                                  className="me-1 mb-sm-8 mb-2"
                                  height={20}
                                  width={44}
                                  onColor="#34c38f"
                                  offColor="#f46a6a"
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 5px"
                                  onChange={() => toggleSsoOnlyLogin()}
                                  checked={getSsoOnlyLogin}
                                />
                              </div>
                            </CardBody>
                          </Card>
                        </Row>
                      </Col>
                    </Collapse>
                    <Row onClick={(e)=>toggleCollapse('okta')}>
                      <Col style={{
                        width: "100%",
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        backdropFilter: 'blur(10px)',
                        WebkitBackdropFilter: 'blur(10px)',
                        borderRadius:'5px',
                        marginTop: "-1px"}}>
                        <div className="p-2 d-flex align-items-center justify-content-between">
                          <h4 role="button" className="change-table-text d-flex gap-1 text-uppercase mt-1">
                            <img src={oktaIcon} style={{height: "24px", color:"secondary"}}
                                 className="bx bxl-google me-2"/>
                            Okta SSO Settings
                          </h4>
                          <i className="mdi mdi-chevron-down font-size-18"></i>
                        </div>
                      </Col>
                    </Row>
                    <Collapse isOpen={ssoCollapse.okta}>
                      <Card className={"mt-3"}>
                        <Row>
                          <Col md={6}>
                            <h4>Instructions to integrate with Okta</h4>
                            <div>
                              <ul>
                                <li>Log in to your <strong>Okta</strong> account.</li>
                                <li>In the left sidebar, navigate to <strong>Applications</strong> and click on <strong>Create App Integration</strong>.</li>
                                <li>Select <strong>OIDC - OpenID Connect</strong> as the <strong>Sign-in method</strong>.</li>
                                <li>Select <strong>Web Application</strong> as the <strong>Application type</strong>.</li>
                                <li>Enter <strong>Temperstack</strong> as the application name.</li>
                                <li>In the <strong>Sign-in redirect URIs</strong> field, enter:
                                  <ul>
                                    <li>
                                      <code>{window.location.origin}/login</code>
                                      <i
                                        className="bx bx-copy-alt"
                                        style={{
                                          marginLeft: '5px',
                                          textAlign: 'center',
                                          verticalAlign: 'middle',
                                          fontSize: 'normal',
                                          cursor: 'pointer',
                                          width: '15px',
                                          height: '15px'
                                        }}
                                        onClick={() => {
                                          copyToClipboard(`${window.location.origin}/login`)
                                        }}></i>
                                    </li>
                                  </ul>
                                </li>
                                <li>In the <strong>Sign-out redirect URIs</strong> field, enter:
                                  <ul>
                                    <li>
                                      <code>{window.location.origin}/logout</code>
                                      <i
                                        className="bx bx-copy-alt"
                                        style={{
                                          marginLeft: '5px',
                                          textAlign: 'center',
                                          verticalAlign: 'middle',
                                          fontSize: 'normal',
                                          cursor: 'pointer',
                                          width: '15px',
                                          height: '15px'
                                        }}
                                        onClick={() => {
                                          copyToClipboard(`${window.location.origin}/logout`)
                                        }}></i>
                                    </li>
                                  </ul>
                                </li>
                                <li>Under <strong>Assignment</strong>, In <strong>Controlled access</strong> select <strong>Limit access to selected groups</strong></li>
                                <li>Under <strong>Selected groups</strong>, Choose the appropriate group</li>
                                <li>Click <strong>Save</strong>.</li>

                                <li>To configure access policies:
                                  <ul>
                                    <li>Go to <strong>Security → API</strong>.</li>
                                    <li>Navigate to the <strong>Authorization Servers</strong> tab.</li>
                                    <li>Click on the <strong>Default</strong> authorization server.</li>
                                    <li>Open the <strong>Access Policies</strong> tab.</li>
                                    <li>Click on <strong>Add New Access Policy</strong>.</li>
                                    <li>Set the <strong>Policy Name</strong> to <strong>Temperstack Policy</strong>.</li>
                                    <li>Give appropriate description</li>
                                    <li>Under <strong>Assign To</strong>, search for the application you created and select it.</li>
                                    <li>Click <strong>Save</strong>.</li>
                                  </ul>
                                </li>
                                <li>To create a rule for the policy:
                                  <ul>
                                    <li>Inside the <strong>Temperstack Policy</strong>, click on <strong>Add Rule</strong>.</li>
                                    <li>Give rule name</li>
                                    <li>Under <strong>Scopes</strong>, select the <strong>OIDC default scopes</strong>.</li>
                                    <li>Leave other settings as default and click <strong>Create Rule</strong>.</li>
                                  </ul>
                                </li>
                                <li>Navigate to the previously created application</li>
                                <li>In the <strong>General</strong> section:
                                  <ul>
                                    <li>Copy the <strong>Client ID</strong> and paste it.</li>
                                    <li>Copy the <strong>Client Secret</strong> and paste it.</li>
                                  </ul>
                                </li>
                                <li>In the top right corner <strong>Profile</strong> section:
                                  <ul>
                                    <li>Copy the <strong>Org URL</strong> and paste it.</li>
                                  </ul>
                                </li>
                                <li>Click Submit</li>
                              </ul>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className='custom-flex-container'>
                              <div className="mb-3 custom-flex-item">
                                <Label className="form-label">Enter Client Id</Label>
                                <Input
                                  name="name"
                                  className="input"
                                  style={{border: '1px solid whitesmoke'}}
                                  placeholder="Enter client id"
                                  type="text"
                                  required
                                  value={clientID}
                                  readOnly={!editOktaIntegration}
                                  onChange={(e)=>setClientID(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="custom-flex-container">
                              <div className="mb-3 custom-flex-item">
                                <Label className="form-label">Client Secret</Label>
                                <Input
                                  name="Client Secret"
                                  className="input"
                                  style={{border: '1px solid whitesmoke'}}
                                  placeholder="Client Secret"
                                  type="password"
                                  required
                                  value={clientSecret}
                                  readOnly={!editOktaIntegration}
                                  onChange={(e)=>setClientSecret(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="custom-flex-container">
                              <div className="mb-3 custom-flex-item">
                                <Label className="form-label">Okta Organization Url</Label>
                                <Input
                                  name="Client Secret"
                                  className="input"
                                  style={{border: '1px solid whitesmoke'}}
                                  placeholder="Organization Url"
                                  type="text"
                                  value={oktaOrgUrl}
                                  required
                                  readOnly={!editOktaIntegration}
                                  onChange={(e)=>setOktaOrgUrl(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className={'d-flex flex-row align-items-center'}>
                              <div className={'w-50'}>
                                {oktaIntegrationExists ? (
                                  !editOktaIntegration ? (
                                    <button
                                      type="button"
                                      className="btn btn-primary w-md"
                                      onClick={() => handleEditOktaIntegration()}
                                    >
                                      Edit
                                    </button>
                                  ) : (
                                    <button
                                      type="submit"
                                      className="btn btn-primary w-md"
                                      onClick={handleOktaSubmit}
                                    >
                                      Submit
                                    </button>
                                  )
                                ) : (
                                  <button
                                    type="submit"
                                    className="btn btn-primary w-md"
                                    onClick={handleOktaSubmit}
                                  >
                                    Submit
                                  </button>
                                )}
                              </div>
                              <div className={'d-flex w-50'}>
                                <h5 className={'me-2'}>Only Allow SSO Login</h5>
                                <Switch
                                  uncheckedIcon={<OffSymbol/>}
                                  checkedIcon={<OnSymbol/>}
                                  className="me-1 mb-sm-8 mb-2"
                                  height={20}
                                  width={44}
                                  onColor="#34c38f"
                                  offColor="#f46a6a"
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 5px"
                                  onChange={() => toggleSsoOnlyLogin()}
                                  checked={getSsoOnlyLogin}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </Collapse>
                  </Row>
                </div>
              </TabPane>

              <TabPane tabId="4">
                <div>
                  <OrganizationServices/>
                </div>
              </TabPane>
              <TabPane tabId="5">
                <div>
                  <OrganizationServiceMapping/>
                </div>
              </TabPane>
              <TabPane tabId="6">
                <Row>
                <Col md={6}>
                    <Card className="h-100">
                      <CardHeader className="border-bottom text-uppercase">
                        <CardTitle tag="h5" className="mb-2">Instructions for Using Webhooks</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="mb-4">
                        <h6 className="mb-1 mt-1">Step 1: Create a Webhook</h6>
                          <p className="mb-3">
                            Create a webhook using the form on the right side. You'll receive a unique webhook URL for your deployments.
                          </p>

                          <h6 className="mb-1">Step 2: Required Parameters</h6>
                          <p className="mb-3">
                            Your webhook request must include these parameters in the JSON body:
                          </p>
                          <ul className="mb-3" style={{ color: '#ffffff' }}>
                            <li><code>name</code>: Description of the change (e.g., "Production Deployment v2.1.0")</li>
                            <li><code>change_data</code>: JSON object containing change details</li>
                            <li><code>changed_by</code>: Identity of the change initiator</li>
                          </ul>

                          <h6 className="mb-2">Step 3: Integrate with Your Deployment Script</h6>
                          <p className="mb-3">
                            Replace <code style={{ color: '#485EC4' }}>https://api.temperstack.com/webhook/change-event</code> in the example below with your actual webhook URL:
                          </p>
                          <div className="position-relative">
                            <pre style={{ color: '#ffffff', border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}
                            >
                              <code ref={codeRef} style={{ color: '#ffffff' }}>
                              {`curl -X POST \\
https://api.temperstack.com/webhook/change-event \\
-H "Content-Type: application/json" \\
-d '{
  "name": "Production Deployment v2.1.0",
  "change_data": {
    "version": "2.1.0",
    "environment": "production",
    "changes": [
      "Added new feature X",
      "Fixed bug Y"
    ]
  },
  "changed_by": "deployment-script"
}'`}
                              </code>
                            </pre>
                            <button 
                              color="primary" 
                              size="sm" 
                              className="btn btn-primary position-absolute top-0 end-0 m-2"
                              onClick={handleCopyCode}
                            >
                              Copy Example
                            </button>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md={5}>
                    <Card className="h-60">
                      <CardHeader className="border-bottom text-uppercase">
                        <CardTitle tag="h5" className="mb-2">Create WebHook</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Form onSubmit={handleWebhookSubmit}>
                        <FormGroup className="mb-4">
                          <Label className="text-white">Name <span className="text-danger">*</span></Label>
                          <Input
                            type="text"
                            value={formData.name}
                            onChange={(e) => handleInputChange('name', e.target.value)}
                            onBlur={() => handleBlur('name')}
                            invalid={shouldShowValidation('name')}
                            className="form-control"
                            style={{ 
                              border: '1px solid whitesmoke',
                              background: 'None',
                              color: 'white'
                            }}
                          />
                          <FormFeedback>Please enter a webhook name</FormFeedback>
                        </FormGroup>
                          {/* <FormGroup>
                            <Label className="form-label">Type</Label>
                            <Select
                              value={selectedType}
                              onChange={setSelectedType}
                              options={typeOptions}
                              styles={customSelectStyles}
                              isSearchable={false}
                            />
                          </FormGroup> */}
                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit"  disabled={!formData.name}>
                              Create
                            </button>
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Card className="w-80 mt-4">
                    <CardHeader className="bg-transparent">
                      <CardTitle tag="h5" className="my-2 mb-2">CHANGE EVENT WEBHOOKS</CardTitle>
                    </CardHeader>
                    <CardBody>
                      {changeEventWebhooks.length > 0 ? (
                        <>
                          <Row className="align-items-center mb-3 mt-2">
                            <Col md="3">
                              <div className="text-white text-center mt-2">Webhook Name</div>
                            </Col>
                            <Col md="3">
                              <div className="text-white text-center">Webhook URL</div>
                            </Col>
                            <Col md="2">
                              <div className="text-white text-center">Created At</div>
                            </Col>
                            <Col md="2">
                              <div className="text-white text-center">Last Used</div>
                            </Col>
                            <Col md="2">
                              <div className="text-white text-center">Updated At</div>
                            </Col>
                          </Row>
                          <div className="card-container">
                            {changeEventWebhooks.map((webhook) => (
                              <div key={webhook.id} className="header">
                                <div 
                                  className="card-item"
                                  onClick={() => toggleWebhookExpansion(webhook.id)}
                                  style={{
                                    backgroundColor: currentHoverItem === webhook.id ? '#382d45' : '',
                                    cursor: 'pointer'
                                  }}
                                  onMouseEnter={() => setCurrentHoverItem(webhook.id)}
                                  onMouseLeave={() => setCurrentHoverItem(null)}
                                >
                                  <div className="p-3">
                                    <Row className="align-items-center">
                                      <Col md="3">
                                        <div className="d-flex justify-content-center">
                                          <a className="text-start resource-name-truncate">
                                            {webhook.name}
                                          </a>
                                        </div>
                                      </Col>
                                      <Col md="3">
                                        <div className="d-flex align-items-center justify-content-center">
                                          <div style={{ 
                                            display: 'inline-flex', 
                                            alignItems: 'center', 
                                            width: '100%', 
                                            justifyContent: 'center' 
                                          }}>
                                            <span 
                                              id={`tooltip-${webhook.id}`} 
                                              className="resource-name-truncate text-center"
                                              style={{ maxWidth: '80%', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                            >
                                              {webhook.integration_url.slice(0, 40)}...
                                            </span>
                                            <Tooltip
                                              placement="top"
                                              isOpen={tooltipOpen[`tooltip-${webhook.id}`]}
                                              target={`tooltip-${webhook.id}`}
                                              toggle={() => toggleTooltip(`tooltip-${webhook.id}`)}
                                            >
                                              {webhook.integration_url}
                                            </Tooltip>
                                            <button
                                              className="btn btn-link btn-sm ms-2 p-0"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(webhook.integration_url);
                                              }}
                                            >
                                              <i className="bx bx-copy font-size-16"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </Col>
                                      <Col md="2">
                                        <div className="text-center">{getLocalDateTime(webhook.created_at)}</div>
                                      </Col>
                                      <Col md="2">
                                        <div className="text-center">{getLocalDateTime(webhook.last_used)}</div>
                                      </Col>
                                      <Col md="2">
                                        <div className="text-center">{getLocalDateTime(webhook.updated_at)}</div>
                                      </Col>
                                    </Row>
                                    {expandedWebhookId === webhook.id && (
                                      <div className="mt-4 border-top pt-3">
                                        <h6 className="mb-3">RECENT CHANGE EVENTS</h6>
                                        {changeEvents.filter((event) => event.key_id === webhook.id).length > 0 ? (
                                          <>
                                            <Row className="mb-2">
                                              <Col md="4">
                                                <div className="text-white text-center">Event Name</div>
                                              </Col>
                                              <Col md="4">
                                                <div className="text-white text-center">Created At</div>
                                              </Col>
                                              <Col md="4">
                                                <div className="text-white text-center">Version</div>
                                              </Col>
                                            </Row>
                                            {changeEvents
                                              .filter((event) => event.key_id === webhook.id)
                                              .slice(0, 10)
                                              .map((event) => (
                                                <div key={event.id} className="header">
                                                  <div 
                                                    className="card-item mt-2"
                                                    onClick={(e) => toggleEventExpansion(event.id, e)}
                                                    style={{ cursor: 'pointer' }}
                                                  >
                                                    <Row className="align-items-center p-2">
                                                      <Col md="4">
                                                        <div className="d-flex justify-content-center">
                                                          <a className="text-start resource-name-truncate">
                                                            {event.name || 'Unnamed Event'}
                                                          </a>
                                                        </div>
                                                      </Col>
                                                      <Col md="4">
                                                        <div className="text-center">
                                                          {event.created_at ? getLocalDateTime(event.created_at) : 'N/A'}
                                                        </div>
                                                      </Col>
                                                      <Col md="4">
                                                        <div className="text-center">
                                                          {event.change_data?.version || 'N/A'}
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                    {expandedEventId === event.id && (
                                                      <div className="mt-3 border-top pt-3 px-2 mx-2">
                                                        <Row>
                                                          <Col md="6">
                                                            <div className="mb-2 mx-2">
                                                              <span className="text-white">Change Type: </span>
                                                              {event.change_type || 'N/A'}
                                                            </div>
                                                            <div className="mb-2 mx-2">
                                                              <span className="text-white">Changed By: </span>
                                                              {event.changed_by || 'N/A'}
                                                            </div>
                                                            <div className="mb-2 mx-2">
                                                              <span className="text-white">Environment: </span>
                                                              {event.change_data?.environment || 'N/A'}
                                                            </div>
                                                            <div className="mb-2 mx-2">
                                                              <span className="text-white">Version: </span>
                                                              {event.change_data?.version || 'N/A'}
                                                            </div>
                                                          </Col>
                                                          <Col md="6">
                                                            <div className="mb-2">
                                                              <span className="text-white">Changes:</span>
                                                              <ul className="mt-1 mb-0">
                                                                {event.change_data?.changes?.length > 0 ? (
                                                                  event.change_data.changes.map((change, index) => (
                                                                    <li key={index}>{change}</li>
                                                                  ))
                                                                ) : (
                                                                  <li>No changes recorded</li>
                                                                )}
                                                              </ul>
                                                            </div>
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              ))}
                                          </>
                                        ) : (
                                          <div className="text-center py-4">
                                            No change events available
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <div className="text-center py-4">
                          No webhooks available
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Row>
              </TabPane>
            </TabContent >
          </div>
          <Modal
              isOpen={showWebhookModal}
              toggle={handleCloseWebhookModal}
              centered
              backdrop="static"
              autoFocus={true}
              size="md"
              className="exampleModal"
              role="dialog"
          >
            <div className="modal-content">
              <ModalHeader toggle={handleCloseWebhookModal}>
                <div className="text-center w-100">
                  <span className="fw-bold">Webhook Created Successfully</span>
                </div>
              </ModalHeader>
              <ModalBody>
                {createEventWebhook && createEventWebhook.integration_key && (
                  <>
                    <div className="mb-3">
                      <Label className="form-label">Webhook Name</Label>
                      <Input
                        type="text"
                        value={createEventWebhook.integration_key.name}
                        readOnly
                        className="input"
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Integration URL</Label>
                      <div className="d-flex align-items-center">
                        <Input
                          type="text"
                          value={createEventWebhook.integration_url}
                          readOnly
                          className="input"
                        />
                        <i
                          className="bx bx-copy bx-sm ms-2"
                          onClick={() => copyToClipboard(createEventWebhook.integration_url)}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </ModalBody>
            </div>
          </Modal>
          {userForDelete && (<Modal
            isOpen={UserDeleteModal}
            role="dialog"
            autoFocus={true}
            keyboard={false}
            centered
            backdrop="static"
            data-toggle="modal"
          >
            <ModalHeader className="border-bottom-2">
              Delete this user?
            </ModalHeader>
            <ModalBody>
              <div className="mb-2"><b>Name:</b> {userForDelete?.name}</div>
              <div className="mb-4"><b>Email:</b> {userForDelete?.email}</div>
              <div className="row text-center">
                <Col lg="6">
                  <Link onClick={cancelUserDeleteModal} className="btn btn-secondary w-md">Cancel</Link>
                </Col>
                <Col lg="6">
                  <Link
                    className="btn btn-primary w-md"
                    onClick={() => {
                      setAction('delete');
                      startLoading();
                      handleUserDelete(userForDelete?.id);
                    }}
                  >
                    Confirm
                  </Link>
                </Col>
              </div>
            </ModalBody>
          </Modal>)}
          {userForEdit && (
            <Modal
              isOpen={userEditModal}
              role="dialog"
              autoFocus={true}
              keyboard={false}
              centered
              backdrop="static"
              data-toggle="modal"
            >
              <ModalHeader className="border-bottom-2">
                Edit User Details
              </ModalHeader>
              <ModalBody>
                <Form
                  className='form-horizontal'
                  onSubmit={(e) => {
                    e.preventDefault();
                    editValidation.handleSubmit();
                  }}
                >
                  <Row>
                    <Col>
                      <div className="mb-3">
                        <Label className="form-label">Name</Label>
                        <Input
                          name="name"
                          className="input"
                          placeholder="Name"
                          type="text"
                          onChange={editValidation.handleChange}
                          onBlur={editValidation.handleBlur}
                          value={editValidation.values.name}
                          invalid={
                            editValidation.touched.name && editValidation.errors.name ? true : false
                          }
                        />
                        {editValidation.touched.name && editValidation.errors.name && (
                          <FormFeedback type="invalid">
                            {editValidation.errors.name}
                          </FormFeedback>
                        )}
                      </div>
                      <div className="custom-flex-container">
                        <div className="mb-3 custom-flex-item">
                          <Label>Select country code</Label>
                          <Select
                            value={editSelectedGroup}
                            onChange={(selectedValue) => {
                              setEditSelectedGroup(selectedValue);
                            }}
                            options={optionGroup}
                            className="select2-selection"
                            required
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 0,
                              colors: {
                                ...theme.colors,
                                neutral0: '#222736',
                                neutral5: '#485EC4',
                                neutral10: '#485EC4',
                                neutral60: '#ffffff',
                                neutral70: '#ffffff',
                                neutral80: '#ffffff',
                                neutral90: '#ffffff',
                                primary: '#485EC4',
                              },
                            })}
                            styles={customStyles}
                          />
                        </div>
                        <div className="mb-3 custom-flex-item">
                          <Label className="form-label">Phone Number</Label>
                          <Input
                            name="phoneNumber"
                            className="input"
                            placeholder="Phone Number"
                            type="tel"
                            onChange={editValidation.handleChange}
                            onBlur={editValidation.handleBlur}
                            value={editValidation.values.phoneNumber}
                            invalid={
                              editValidation.touched.phoneNumber && editValidation.errors.phoneNumber ? true : false
                            }
                          />
                          {editValidation.touched.phoneNumber && editValidation.errors.phoneNumber && (
                            <FormFeedback type="invalid">
                              {editValidation.errors.phoneNumber}
                            </FormFeedback>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={cancelUserEditModal}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Update
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </ModalBody>
            </Modal>
          )}

          {teamToUpdate && (<Modal
            isOpen={addUserModal}
            role="dialog"
            autoFocus={true}
            keyboard={false}
            centered
            backdrop="static"
            data-toggle="modal"
          >
            <ModalHeader className="border-bottom-2">
              Add User to Team {teamToUpdate?.name}
            </ModalHeader>
            <ModalBody>
              <Container fluid>
                <div style={{marginBottom: '20px'}}>
                  <Select
                    isMulti
                    value={selectedUsers}
                    options={
                      nonTeamMembers.map(user =>
                        ({value: user.id, label: user.name})
                      )}
                    onChange={(selectedValue) => {
                      handleSelectUsers(selectedValue);
                    }}
                    className="select2-selection"
                    required
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>

                <div className="row text-center">
                  <Col lg="6">
                    <Link onClick={cancelAddUserModal} className="btn btn-secondary w-md">Cancel</Link>
                  </Col>
                  <Col lg="6">
                    <Link
                      className="btn btn-primary w-md"
                      onClick={() => {
                        handleAddUser(teamToUpdate?.id);
                      }}
                    >
                      Confirm
                    </Link>
                  </Col>
                </div>
              </Container>
            </ModalBody>
          </Modal>)}

          {teamToUpdate && (<Modal
            isOpen={mapServiceModal}
            role="dialog"
            autoFocus={true}
            keyboard={false}
            centered
            backdrop="static"
            data-toggle="modal"
          >
            <ModalHeader className="border-bottom-2">
              Map Service to Team {teamToUpdate?.name}
            </ModalHeader>
            <ModalBody>
              <Container fluid>
                <div style={{marginBottom: '20px'}}>
                  <Select
                    isMulti
                    value={selectedServices}
                    options={
                      unmappedServices.map(service =>
                        ({value: service.id, label: service.name})
                      )}
                    onChange={(selectedValue) => {
                      handleSelectServices(selectedValue);
                    }}
                    className="select2-selection"
                    required
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>

                <div className="row text-center">
                  <Col lg="6">
                    <Link onClick={cancelMapServiceModal} className="btn btn-secondary w-md">Cancel</Link>
                  </Col>
                  <Col lg="6">
                    <Link
                      className="btn btn-primary w-md"
                      onClick={() => {
                        handleMapService(teamToUpdate?.id);
                      }}
                    >
                      Confirm
                    </Link>
                  </Col>
                </div>
              </Container>
            </ModalBody>
          </Modal>)}

          {isLoading && <Loader
            isOpen={true}
            lottieJson={action === 'invite' || action === 'reinvite' ? sendingEmailLottie : deleteUserLottie}
            messageHeader={action === 'invite' ? 'Sending Invite' : action === 'reinvite' ? 'Resending Invite' : "Deleting User"}
            message={action === 'invite' || action === 'reinvite' ? "Please wait while the the email is being sent. Please ask the user to check email." : "Please wait while we delete the user"}
          />}
        </Container>
      </div>
      <Modal
        isOpen={showStatusPageModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={cancelUpdate}
      >
        <ModalHeader className="border-bottom-0">
          <h4 className="modal-title" id="statusPageModal">
            {publishStatusPage
              ? "Publish Status Page"
              : "Unpublish Status Page"
            }
          </h4>
        </ModalHeader>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                {publishStatusPage ? (
                  <div className="mt-4">
                    <p className="mb-2">You are about to make your Status Page public.</p>
                    <p>
                      Anyone who visits{' '}
                      <Link to={`https://${organizationDetail?.domain}/status-page`}
                            target={"_blank"}
                            className="text-primary">
                        {organizationDetail?.domain}/status-page
                      </Link>
                      {' '}will be able to view your status updates.
                    </p>
                  </div>
                ) : (
                  <div className="mt-4">
                    <p className="mb-2">You are about to make your Status Page private.</p>
                    <p>The page will no longer be accessible to the public.</p>
                  </div>
                )}

                <Row className="full-width mt-4">
                  <Col lg="6" className="mb-2 mb-lg-0">
                    <button
                      onClick={cancelUpdate}
                      className="btn btn-secondary w-100"
                      type="button"
                    >
                      Cancel
                    </button>
                  </Col>
                  <Col lg="6">
                    <button
                      onClick={updateStatusPageVisibility}
                      className="btn btn-primary w-100"
                      type="button"
                    >
                      {publishStatusPage ? "Yes, Publish Page" : "Yes, Make Private"}
                    </button>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

Organization.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Organization);